import { SvgIcon } from "@mui/material"

export const UnFlagged = ({ width = "24", height = "24" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentcolor"
      d="M6 21q-.425 0-.713-.288T5 20V5q0-.425.288-.713T6 4h7.175q.35 0 .625.225t.35.575L14.4 6H19q.425 0 .713.288T20 7v8q0 .425-.288.713T19 16h-5.175q-.35 0-.625-.225t-.35-.575L12.6 14H7v6q0 .425-.288.713T6 21Zm6.5-11Zm2.15 4H18V8h-5.25l-.4-2H7v6h7.25l.4 2Z"
    />
  </svg>
)

export const Flagged = ({ fill, width = "24", height = "24" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
  >
    <path
      fill={fill}
      d="M6 21q-.425 0-.713-.288T5 20V5q0-.425.288-.713T6 4h7.175q.35 0 .625.225t.35.575L14.4 6H19q.425 0 .713.288T20 7v8q0 .425-.288.713T19 16h-5.175q-.35 0-.625-.225t-.35-.575L12.6 14H7v6q0 .425-.288.713T6 21Z"
    />
  </svg>
)

export const Starred = ({
  color = "#ffd600",
  width = "24",
  height = "24",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="M0 0h24v24H0z" />
      <path
        fill={color}
        d="m8.243 7.34l-6.38.925l-.113.023a1 1 0 0 0-.44 1.684l4.622 4.499l-1.09 6.355l-.013.11a1 1 0 0 0 1.464.944l5.706-3l5.693 3l.1.046a1 1 0 0 0 1.352-1.1l-1.091-6.355l4.624-4.5l.078-.085a1 1 0 0 0-.633-1.62l-6.38-.926l-2.852-5.78a1 1 0 0 0-1.794 0L8.243 7.34z"
      />
    </g>
  </svg>
)

export const UnStarred = ({ width = "24", height = "24" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m12 17.75l-6.172 3.245l1.179-6.873l-5-4.867l6.9-1l3.086-6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"
    />
  </svg>
)

export const HomeColors = ({ width = "24", height = "24" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 48 48"
  >
    <path fill="#E8EAF6" d="M42 39H6V23L24 6l18 17z" />
    <path fill="#C5CAE9" d="m39 21l-5-5V9h5zM6 39h36v5H6z" />
    <path
      fill="#B71C1C"
      d="M24 4.3L4 22.9l2 2.2L24 8.4l18 16.7l2-2.2z"
    />
    <path fill="#D84315" d="M18 28h12v16H18z" />
    <path fill="#01579B" d="M21 17h6v6h-6z" />
    <path
      fill="#FF8A65"
      d="M27.5 35.5c-.3 0-.5.2-.5.5v2c0 .3.2.5.5.5s.5-.2.5-.5v-2c0-.3-.2-.5-.5-.5z"
    />
  </svg>
)

export const Search = ({
  stroke = "#000",
  fill = "#2bff00",
  width = "48",
  height = "48",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 48 48"
  >
    <g fill="none" strokeLinejoin="round" strokeWidth="4">
      <path
        fill={fill}
        stroke={stroke}
        d="M21 38C30.3888 38 38 30.3888 38 21C38 11.6112 30.3888 4 21 4C11.6112 4 4 11.6112 4 21C4 30.3888 11.6112 38 21 38Z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        d="M26.657 14.3431C25.2093 12.8954 23.2093 12 21.0001 12C18.791 12 16.791 12.8954 15.3433 14.3431"
      />
      <path
        stroke="red"
        strokeLinecap="round"
        d="M33.2216 33.2217L41.7069 41.707"
      />
    </g>
  </svg>
)

export const Editor = ({
  stroke,
  fill,
  width = "24",
  height = "24",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 48 48"
  >
    <g
      fill="none"
      stroke={stroke}
      strokeLinejoin="round"
      strokeWidth="4"
    >
      <path
        strokeLinecap="round"
        d="M42 26V40C42 41.1046 41.1046 42 40 42H8C6.89543 42 6 41.1046 6 40V8C6 6.89543 6.89543 6 8 6L22 6"
      />
      <path
        fill={fill}
        d="M14 26.7199V34H21.3172L42 13.3081L34.6951 6L14 26.7199Z"
      />
    </g>
  </svg>
)

export const DeleteSolid = ({
  fill,
  width = "24",
  height = "24",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 26 26"
  >
    <path
      fill={fill}
      d="M11.5-.031c-1.958 0-3.531 1.627-3.531 3.594V4H4c-.551 0-1 .449-1 1v1H2v2h2v15c0 1.645 1.355 3 3 3h12c1.645 0 3-1.355 3-3V8h2V6h-1V5c0-.551-.449-1-1-1h-3.969v-.438c0-1.966-1.573-3.593-3.531-3.593h-3zm0 2.062h3c.804 0 1.469.656 1.469 1.531V4H10.03v-.438c0-.875.665-1.53 1.469-1.53zM6 8h5.125c.124.013.247.031.375.031h3c.128 0 .25-.018.375-.031H20v15c0 .563-.437 1-1 1H7c-.563 0-1-.437-1-1V8zm2 2v12h2V10H8zm4 0v12h2V10h-2zm4 0v12h2V10h-2z"
    />
  </svg>
)

export const DeleteIcon = ({ width = "24", height = "24", fill }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 824 925"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M154 260h568v700H154z" fill={fill}></path>
      <path
        d="M624.428 261.076v485.956c0 57.379-46.737 103.894-104.391 103.894h-362.56v107.246h566.815V261.076h-99.864z"
        fill={fill}
      ></path>
      <path
        d="M320.5 870.07c-8.218 0-14.5-6.664-14.5-14.883V438.474c0-8.218 6.282-14.883 14.5-14.883s14.5 6.664 14.5 14.883v416.713c0 8.219-6.282 14.883-14.5 14.883zM543.5 870.07c-8.218 0-14.5-6.664-14.5-14.883V438.474c0-8.218 6.282-14.883 14.5-14.883s14.5 6.664 14.5 14.883v416.713c0 8.219-6.282 14.883-14.5 14.883z"
        fill="#152B3C"
      ></path>
      <path
        d="M721.185 345.717v-84.641H164.437z"
        fill="#030504"
      ></path>
      <path
        d="M633.596 235.166l-228.054-71.773 31.55-99.3 228.055 71.773z"
        fill={fill}
      ></path>
      <path
        d="M847.401 324.783c-2.223 0-4.475-0.333-6.706-1.034L185.038 117.401c-11.765-3.703-18.298-16.239-14.592-27.996 3.706-11.766 16.241-18.288 27.993-14.595l655.656 206.346c11.766 3.703 18.298 16.239 14.592 27.996-2.995 9.531-11.795 15.631-21.286 15.631z"
        fill={fill}
      ></path>
    </g>
  </svg>
)

export const PaletteDuotone = ({
  fill,
  width = "24",
  height = "24",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
  >
    <g fill={fill}>
      <path d="M7 18a1 1 0 1 1-2 0a1 1 0 0 1 2 0Z" />
      <path
        d="M10 6v12a4 4 0 0 1-8 0V6a4 4 0 1 1 8 0Z"
        opacity=".4"
      />
      <path
        d="m9.248 20.336l3.974-3.975l5.838-6.09a4.042 4.042 0 0 0-5.776-5.655L10 7.9V18c0 .872-.279 1.679-.752 2.336Z"
        opacity=".7"
      />
      <path d="m13.222 16.362l-3.974 3.974A4 4 0 0 1 6 22h11.9a4 4 0 1 0 0-8h-2.414l-2.264 2.362Z" />
    </g>
  </svg>
)

export const PushPinRed = ({ width = "24", height = "24" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 64 64"
  >
    <path
      fill="#aeaeae"
      d="M4.516 61.56c-1.652 1.683-3.155 2.89-4.132 1.903c-.979-.987.193-2.521 1.847-4.202l31.507-36.01c1.647-1.685 5.04-.988 6.02-.004c.977.983 1.687 4.417.037 6.102l-35.27 32.21"
    />
    <path
      fill="#7c7b7d"
      d="m3.188 60.35l31.501-36c1.438-1.47 4.195-1.13 5.532-.364c-.149-.298-.303-.561-.474-.732c-.973-.981-4.362-1.678-6.01.009L2.232 59.273C.578 60.954-.594 62.487.38 63.475c.187.187.393.271.614.313c-.048-.936.923-2.133 2.196-3.433"
    />
    <g fill="#be202e">
      <path d="M46.672 63.03c-3.718 3.742-16.961-3.674-29.577-16.568C4.477 33.567-2.741 20.079.975 16.342c3.718-3.745 16.959 3.674 29.58 16.571c12.616 12.893 19.832 26.378 16.11 30.12" />
      <path d="M38.682 32.09c6.838-6.887 15.869-8.902 20.17-4.5L36.006 4.239c4.301 4.395 2.245 13.547-4.595 20.429c-6.836 6.884-15.87 8.905-20.17 4.505l22.848 23.346c-4.303-4.397-2.248-13.544 4.591-20.429" />
    </g>
    <path
      fill="#a51e2d"
      d="M34.926 28.396c6.838-6.884 8.894-16.03 4.586-20.432l18.451 18.852c.313.23.615.486.894.773L36.011 4.24c4.301 4.395 2.245 13.547-4.595 20.429c-6.836 6.884-15.87 8.905-20.17 4.505l4.402 4.497c4.568 3.341 12.883 1.163 19.281-5.275"
    />
    <path
      fill="#be202e"
      d="M62.51 30.75c-2.41 2.426-10.982-2.377-19.16-10.73C35.182 11.668 30.506 2.93 32.912.511c2.405-2.423 10.985 2.382 19.16 10.732c8.169 8.35 12.84 17.09 10.437 19.507"
    />
    <path
      fill="#a51e2d"
      d="M56.6 24.713c-1.441 1.455-6.593-1.433-11.501-6.448c-4.91-5.02-7.715-10.261-6.271-11.718c1.448-1.453 6.593 1.435 11.505 6.446c4.91 5.02 7.717 10.261 6.267 11.72"
    />
  </svg>
)

export const PushPinSolid = ({
  fill,
  width = "24",
  height = "24",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 256 256"
  >
    <path
      fill={fill}
      d="M51 37.31a4 4 0 0 0-6 5.38L75.35 76c-9.93.88-22.26 4.54-34.87 14.71a12 12 0 0 0-1 17.84l51.13 51.13l-45.44 45.49a4 4 0 0 0 5.66 5.66l45.46-45.47l51.12 51.12a12 12 0 0 0 8.49 3.52h.85a12 12 0 0 0 8.73-4.74a81.06 81.06 0 0 0 13.19-25.55l26.37 29a4 4 0 1 0 5.92-5.38Zm108.08 173.11a4 4 0 0 1-6 .4L45.17 102.93a4 4 0 0 1 .33-6c14.08-11.36 27.62-13.5 37-13.12l89.69 98.65c-2.12 11.46-8.19 21.46-13.11 27.96Zm73.41-109.25L187.85 146a4 4 0 0 1-5.67-5.64l44.65-44.8a4 4 0 0 0 0-5.66l-60.68-60.73a4 4 0 0 0-5.66 0l-41.22 41.36a4 4 0 0 1-5.67-5.65l41.23-41.36a12 12 0 0 1 17 0l60.66 60.68a12 12 0 0 1 0 16.97Z"
    />
  </svg>
)

export const ChevronUpWide = ({
  fill,
  width = "24",
  height = "24",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
  >
    <path
      fill={fill}
      fillRule="evenodd"
      d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
    />
  </svg>
)

export const ChevronLeftWide = ({
  fill,
  width = "24",
  height = "24",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
  >
    <path
      fill={fill}
      fillRule="evenodd"
      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
    />
  </svg>
)

export const InfoSolid = ({ fill, width = "24", height = "24" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 36 36"
  >
    <circle
      cx="20.75"
      cy="6"
      r="4"
      fill={fill}
      className="clr-i-solid clr-i-solid-path-1"
    />
    <path
      fill={fill}
      d="M24.84 26.23a1 1 0 0 0-1.4.29a16.6 16.6 0 0 1-3.51 3.77c-.33.25-1.56 1.2-2.08 1c-.36-.11-.15-.82-.08-1.12l.53-1.57c.22-.64 4.05-12 4.47-13.3c.62-1.9.35-3.77-2.48-3.32c-.77.08-8.58 1.09-8.72 1.1a1 1 0 0 0 .13 2s3-.39 3.33-.42a.88.88 0 0 1 .85.44a2.47 2.47 0 0 1-.07 1.71c-.26 1-4.37 12.58-4.5 13.25a2.78 2.78 0 0 0 1.18 3a5 5 0 0 0 3.08.83a8.53 8.53 0 0 0 3.09-.62c2.49-1 5.09-3.66 6.46-5.75a1 1 0 0 0-.28-1.29Z"
      className="clr-i-solid clr-i-solid-path-2"
    />
    <path fill="none" d="M0 0h36v36H0z" />
  </svg>
)

export const SunMode = ({ fill }) => (
  <svg
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    className="sun-icon"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <g id="sun" transform="translate(-2 -2)">
        {" "}
        <circle
          id="secondary"
          fill={fill}
          cx="4"
          cy="4"
          r="4"
          transform="translate(8 8)"
        ></circle>{" "}
        <path
          id="primary"
          d="M12,3V4M5.64,5.64l.7.7M3,12H4m1.64,6.36.7-.7M12,21V20m6.36-1.64-.7-.7M21,12H20M18.36,5.64l-.7.7M12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Z"
          fill="none"
          stroke="#737373"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        ></path>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const MoonMode = ({ fill }) => (
  <svg
    viewBox="-1.5 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    className="moon-icon"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <g id="moon-alt-6" transform="translate(-4 -2)">
        {" "}
        <path
          id="secondary"
          fill={fill}
          d="M5,12a14,14,0,0,0,2.808,8.407A8.9,8.9,0,0,0,11,21,9,9,0,1,0,11,3a8.9,8.9,0,0,0-3.19.59A14,14,0,0,0,5,12Z"
        ></path>{" "}
        <path
          id="primary"
          d="M5,12a14,14,0,0,0,2.808,8.407A8.9,8.9,0,0,0,11,21,9,9,0,1,0,11,3a8.9,8.9,0,0,0-3.19.59A14,14,0,0,0,5,12Z"
          fill="none"
          stroke="#737373"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        ></path>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const SystemSettingsMode = ({ fill }) => (
  <svg
    fill="#000000"
    viewBox="0 0 24 24"
    id="settings"
    data-name="Flat Line"
    xmlns="http://www.w3.org/2000/svg"
    className="system-icon flat-line"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        id="secondary"
        d="M20,10h-.59a1,1,0,0,1-.94-.67v0a1,1,0,0,1,.2-1.14l.41-.41a1,1,0,0,0,0-1.42L17.66,4.93a1,1,0,0,0-1.42,0l-.41.41a1,1,0,0,1-1.14.2h0A1,1,0,0,1,14,4.59V4a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1v.59a1,1,0,0,1-.67.94h0a1,1,0,0,1-1.14-.2l-.41-.41a1,1,0,0,0-1.42,0L4.93,6.34a1,1,0,0,0,0,1.42l.41.41a1,1,0,0,1,.2,1.14v0a1,1,0,0,1-.94.67H4a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h.59a1,1,0,0,1,.94.67v0a1,1,0,0,1-.2,1.14l-.41.41a1,1,0,0,0,0,1.42l1.41,1.41a1,1,0,0,0,1.42,0l.41-.41a1,1,0,0,1,1.14-.2h0a1,1,0,0,1,.67.94V20a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1v-.59a1,1,0,0,1,.67-.94h0a1,1,0,0,1,1.14.2l.41.41a1,1,0,0,0,1.42,0l1.41-1.41a1,1,0,0,0,0-1.42l-.41-.41a1,1,0,0,1-.2-1.14v0a1,1,0,0,1,.94-.67H20a1,1,0,0,0,1-1V11A1,1,0,0,0,20,10Zm-8,5a3,3,0,1,1,3-3A3,3,0,0,1,12,15Z"
        style={{ fill: fill, strokeWidth: 2 }}
      ></path>
      <path
        id="primary"
        d="M15,12a3,3,0,1,1-3-3A3,3,0,0,1,15,12Zm5-2h-.59a1,1,0,0,1-.94-.67v0a1,1,0,0,1,.2-1.14l.41-.41a1,1,0,0,0,0-1.42L17.66,4.93a1,1,0,0,0-1.42,0l-.41.41a1,1,0,0,1-1.14.2h0A1,1,0,0,1,14,4.59V4a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1v.59a1,1,0,0,1-.67.94h0a1,1,0,0,1-1.14-.2l-.41-.41a1,1,0,0,0-1.42,0L4.93,6.34a1,1,0,0,0,0,1.42l.41.41a1,1,0,0,1,.2,1.14v0a1,1,0,0,1-.94.67H4a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h.59a1,1,0,0,1,.94.67v0a1,1,0,0,1-.2,1.14l-.41.41a1,1,0,0,0,0,1.42l1.41,1.41a1,1,0,0,0,1.42,0l.41-.41a1,1,0,0,1,1.14-.2h0a1,1,0,0,1,.67.94V20a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1v-.59a1,1,0,0,1,.67-.94h0a1,1,0,0,1,1.14.2l.41.41a1,1,0,0,0,1.42,0l1.41-1.41a1,1,0,0,0,0-1.42l-.41-.41a1,1,0,0,1-.2-1.14v0a1,1,0,0,1,.94-.67H20a1,1,0,0,0,1-1V11A1,1,0,0,0,20,10Z"
        style={{
          fill: "none",
          stroke: "#737373",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
        }}
      ></path>
    </g>
  </svg>
)

export const MoveRight = ({ width = "24", height = "24" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
  >
    <path fill="#dc143c" d="m16 10l-5-4v3H6v2h5v3z" />
    <path fill="teal" d="M0 2h20v16H0zm5 6v4h5v4h8V4h-8v4z" />
  </svg>
)
export const MoveLeft = ({ width = "24", height = "24" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
  >
    <path fill="#dc143c" d="m4 10l5-4v3h5v2H9v3z" />
    <path fill="teal" d="M0 2v16h20V2zm2 2h8v4h5v4h-5v4H2z" />
  </svg>
)

export const ResetColors = ({ width = "24", height = "24" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
  >
    <path
      fill="teal"
      d="m10.93 7.83l4.77 4.77c-.62-1.81-2.17-4.24-3.71-6.24c-.35.47-.71.96-1.06 1.47zM12 18c.96 0 1.83-.36 2.53-.92l-5.72-5.72C8.32 12.38 8 13.31 8 14c0 2.21 1.79 4 4 4z"
      opacity=".3"
    />
    <path
      fill="crimson"
      d="M12 6.36c1.53 2 3.08 4.43 3.71 6.24l2.23 2.23c.03-.27.06-.55.06-.83c0-3.98-6-10.8-6-10.8s-1.18 1.35-2.5 3.19l1.44 1.44c.34-.51.7-1 1.06-1.47zM5.41 5.14L4 6.55l3.32 3.32C6.55 11.33 6 12.79 6 14c0 3.31 2.69 6 6 6c1.52 0 2.9-.57 3.95-1.5l2.63 2.63L20 19.72L5.41 5.14zM12 18c-2.21 0-4-1.79-4-4c0-.69.32-1.62.81-2.64l5.72 5.72c-.7.56-1.57.92-2.53.92z"
    />
  </svg>
)

export const Shrug = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="128"
    height="128"
    viewBox="0 0 128 128"
  >
    <path
      fill="#543930"
      d="M96.78 69.65c-1.38-1.93-.2-4.2 1.95-7.11c3.41-4.61 6.51-14.69 1.36-23.93c.02-.06-.99-1.6-.97-1.65l-1.64.12c-.53-.01-18.43 2.14-36.35 4.32c-17.91 2.19-35.81 4.41-36.32 4.55c0 0-2.2 2.07-2.17 2.12c-2.77 10.2 2.66 19.25 7.08 22.9c2.78 2.3 4.49 4.22 3.6 6.43c-.85 2.14-4.09 2.83-4.09 2.83s1.01 1.96 2.96 2.85c1.81.82 3.91.81 5.34.67c0 0 6.54 7.06 21.15 5.27l8.13-1l8.13-.99C89.55 85.25 94.2 76.82 94.2 76.82c1.43-.21 3.46-.7 5.03-1.93c1.68-1.33 2.19-3.47 2.19-3.47s-3.3.1-4.64-1.77z"
    />
    <radialGradient
      id="notoPersonShrugging0"
      cx="102.755"
      cy="71.508"
      r="21.447"
      gradientTransform="matrix(.9926 -.1212 .0595 .4876 -27.686 51.577)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".728" stopColor="#6D4C41" stopOpacity="0" />
      <stop offset="1" stopColor="#6D4C41" />
    </radialGradient>
    <path
      fill="url(#notoPersonShrugging0)"
      d="m66.81 88.02l-1.05-8.58l25.72-5.23l2.72 2.62s-4.65 8.42-19.26 10.21l-8.13.98z"
    />
    <radialGradient
      id="notoPersonShrugging1"
      cx="81.631"
      cy="74.697"
      r="6.338"
      gradientTransform="matrix(-.8477 .5304 -.3935 -.6289 197.742 71.95)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".663" stopColor="#6D4C41" />
      <stop offset="1" stopColor="#6D4C41" stopOpacity="0" />
    </radialGradient>
    <path
      fill="url(#notoPersonShrugging1)"
      d="M93.69 73.08c-4.61-5.43 3.75-8.69 3.75-8.69h.01c-1.27 2.05-1.76 3.76-.68 5.26c1.35 1.87 4.66 1.77 4.66 1.77s-3.98 4.51-7.74 1.66z"
    />
    <radialGradient
      id="notoPersonShrugging2"
      cx="98.058"
      cy="92.627"
      r="27.84"
      gradientTransform="matrix(-.1949 -.9808 .8175 -.1624 24.056 163.683)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".725" stopColor="#6D4C41" stopOpacity="0" />
      <stop offset="1" stopColor="#6D4C41" />
    </radialGradient>
    <path
      fill="url(#notoPersonShrugging2)"
      d="M100.11 38.61c5.01 8.94 2.13 19.13-1.18 23.68c-.45.62-2.4 3.07-2.69 4.87c0 0-10.15-11.04-13.61-17.83c-.7-1.37-1.36-2.79-1.6-4.31c-.19-1.14-.18-2.52.36-3.57c.66-1.29 18.14-3.78 18.14-3.78l.58.94z"
    />
    <radialGradient
      id="notoPersonShrugging3"
      cx="44.079"
      cy="92.627"
      r="27.84"
      gradientTransform="matrix(-.0467 -.9989 -.8325 .039 124.024 97.253)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".725" stopColor="#6D4C41" stopOpacity="0" />
      <stop offset="1" stopColor="#6D4C41" />
    </radialGradient>
    <path
      fill="url(#notoPersonShrugging3)"
      d="M22.65 48.06c-2.71 9.88 2.53 19.08 6.84 22.7c.59.5 3.07 2.4 3.79 4.08c0 0 7.2-13.15 8.92-20.58c.35-1.5.64-3.03.52-4.57c-.09-1.15-.44-2.49-1.21-3.38c-.95-1.09-1.86-.66-3.23-.49c-2.62.32-14.16 1.05-15.05 1.16c0 .01-.58 1.08-.58 1.08z"
    />
    <radialGradient
      id="notoPersonShrugging4"
      cx="48.776"
      cy="71.508"
      r="21.447"
      gradientTransform="matrix(-.9926 .1212 .0595 .4876 96.236 36.452)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".728" stopColor="#6D4C41" stopOpacity="0" />
      <stop offset="1" stopColor="#6D4C41" />
    </radialGradient>
    <path
      fill="url(#notoPersonShrugging4)"
      d="m66.85 88.01l-1.05-8.58l-26.23 1.11l-2.01 3.19S44.1 90.79 58.71 89l8.14-.99z"
    />
    <radialGradient
      id="notoPersonShrugging5"
      cx="27.653"
      cy="74.697"
      r="6.338"
      gradientTransform="matrix(.9504 .311 .2307 -.7051 -12.797 120.696)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".663" stopColor="#6D4C41" />
      <stop offset="1" stopColor="#6D4C41" stopOpacity="0" />
    </radialGradient>
    <path
      fill="url(#notoPersonShrugging5)"
      d="M37.17 79.98c3.17-6.38-5.73-7.53-5.73-7.53l-.01.01c1.73 1.68 2.61 3.23 1.92 4.94c-.85 2.14-4.09 2.83-4.09 2.83s4.95 3.41 7.91-.25z"
    />
    <linearGradient
      id="notoPersonShrugging6"
      x1="16.398"
      x2="16.398"
      y1="54.489"
      y2="84.711"
      gradientTransform="matrix(1 0 0 -1 0 128)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".5" stopColor="#FFCA28" />
      <stop offset="1" stopColor="#FFB300" />
    </linearGradient>
    <path
      fill="url(#notoPersonShrugging6)"
      d="M26.28 62.35a38.066 38.066 0 0 1-6.08-5.66c-.95-1.05-2.83-2.78-4.69-2.62c-.38.03-.87.16-1.34.51c-1.27-1.64-4.2-6.04-5.66-9.92c-.59-1.23-1.62-1.43-2.33-1.23c-1.26.37-2.07 1.97-1.88 3.74c.62 5.9 5.24 13.09 6.97 14.78l-.03.02c3.4 4.14 3.72 10.18 3.72 10.24c.02.47.37.86.83.94l9.51 1.59c.06.01.11.01.17.01c.42 0 .81-.27.94-.68c.63-1.85 2.09-6.25 2.11-7.25c.06-2.92-1.79-4.2-2.24-4.47z"
    />
    <linearGradient
      id="notoPersonShrugging7"
      x1="111.822"
      x2="111.822"
      y1="55.186"
      y2="84.222"
      gradientTransform="matrix(1 0 0 -1 0 128)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".5" stopColor="#FFCA28" />
      <stop offset="1" stopColor="#FFB300" />
    </linearGradient>
    <path
      fill="url(#notoPersonShrugging7)"
      d="M122.08 43.45c-.71-.22-1.77-.02-2.41 1.31c-1.43 3.8-4.36 8.19-5.63 9.83a2.68 2.68 0 0 0-1.34-.51c-1.86-.16-3.74 1.57-4.7 2.63a37.9 37.9 0 0 1-6.07 5.64c-.45.27-2.3 1.54-2.24 4.48c.02 1 1.48 5.41 2.11 7.25c.14.41.52.68.94.68c.06 0 .11 0 .17-.01l9.51-1.59a.99.99 0 0 0 .83-1.06c0-.05-.34-5.39 3.71-10.11l-.03-.02c1.73-1.68 6.2-9.03 6.98-14.77c.24-1.75-.55-3.37-1.83-3.75z"
    />
    <linearGradient
      id="notoPersonShrugging8"
      x1="64.065"
      x2="64.065"
      y1="45.986"
      y2=".64"
      gradientTransform="matrix(1 0 0 -1 0 128)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#F78C1F" />
      <stop offset=".481" stopColor="#F47F12" />
      <stop offset=".998" stopColor="#EF6C00" />
    </linearGradient>
    <path
      fill="url(#notoPersonShrugging8)"
      d="M115.74 111.06c.14 7.1-5.58 12.94-12.69 12.94c-1.4 0-2.72-.29-3.9-.84c-.04-.02-.08-.03-.11-.05a8.03 8.03 0 0 1-1.65-.97a9.795 9.795 0 0 1-1.89-1.86a9.44 9.44 0 0 1-1.91-4.59l-.02.01l-.01.01V124H34.58v-8.41l-.04-.02c0 .02 0 .03-.01.04v.01c-.43 3.23-2.5 6-5.39 7.36h-.01c-1.23.58-2.59.9-4.05.9c-7.1 0-12.83-5.83-12.69-12.94l.11-40.55c.02-.8.65-1.45 1.45-1.5l12.81-.75h.11c.78 0 1.45.59 1.54 1.38l2.68 18.97c4.18-3.58 9.95-6.21 17.88-6.21c2.62 0 27.59.12 30.2.12c7.93 0 13.7 2.63 17.88 6.2l2.67-18.97c.1-.79.77-1.38 1.55-1.38c.04 0 .07.01.11.01l12.81.75c.8.05 1.42.7 1.45 1.5l.1 40.55z"
    />
    <path
      fill="#DA6727"
      d="M99.04 123.11a8.03 8.03 0 0 1-1.65-.97a9.795 9.795 0 0 1-1.89-1.86a9.44 9.44 0 0 1-1.91-4.59l-.02.01l-.38-10.68s.63 9.15 5.85 18.09zm-64.13-18.09l-.38 10.59v.01c-.43 3.23-2.5 6-5.39 7.36c5.14-8.9 5.77-17.96 5.77-17.96z"
    />
    <path
      fill="#E59600"
      d="M54.92 78.33v9.98c0 4.51 3.62 8.17 9.08 8.17s9.08-3.66 9.08-8.17v-9.98H54.92zm31.57-34.55l-49.72 6.05c-5.36.65-9.18 5.86-8.48 11.57c.69 5.71 5.65 9.85 11.01 9.2l49.72-6.05c5.36-.65 9.18-5.86 8.48-11.57c-.69-5.71-5.65-9.85-11.01-9.2z"
    />
    <path
      fill="#FFCA28"
      d="M57.28 10.99C41.44 12.92 28.84 31.63 31.81 56c2.95 24.23 19.51 34.38 34.9 32.51S95.75 72.82 92.8 48.58C89.83 24.21 73.11 9.07 57.28 10.99z"
    />
    <path
      fill="#795548"
      d="M71.05 75.72c.22 2.78-2.21 3.55-5.27 3.79c-3.06.24-5.58-.21-5.8-2.92c-.22-2.86 2.12-4.82 5.17-5.06c3.06-.24 5.67 1.28 5.9 4.19z"
    />
    <path
      fill="#E59600"
      d="M67.1 62.41c-.1-.03-.2-.04-.3-.04l-6.44.78c-.1.02-.19.06-.28.11c-.56.31-.8.95-.45 1.56c.35.61 1.85 2.26 4.44 1.95c2.58-.31 3.64-2.28 3.84-2.95c.19-.68-.2-1.24-.81-1.41z"
    />
    <g fill="#404040">
      <ellipse
        cx="47.55"
        cy="56.45"
        rx="4.49"
        ry="4.65"
        transform="rotate(-6.851 47.543 56.444)"
      />
      <ellipse
        cx="77.32"
        cy="52.87"
        rx="4.49"
        ry="4.65"
        transform="rotate(-6.851 77.317 52.867)"
      />
    </g>
    <path
      fill="#6D4C41"
      d="M53.17 47.35c-.98-1.02-3.15-2.42-6.96-1.97c-3.81.46-5.58 2.33-6.3 3.56c-.32.54-.15 1.1.15 1.42c.28.29 1.03.51 1.78.15s2.2-1.34 4.78-1.67c2.58-.29 4.22.32 5.03.49c.82.17 1.5-.21 1.7-.56c.23-.38.26-.97-.18-1.42zm29.78-3.58c-.98-1.02-3.15-2.42-6.96-1.97c-3.81.46-5.58 2.33-6.29 3.56c-.32.54-.15 1.1.15 1.42c.28.29 1.03.51 1.79.15s2.2-1.34 4.78-1.67c2.58-.29 4.22.32 5.03.49c.82.17 1.5-.21 1.7-.56c.21-.38.23-.97-.2-1.42z"
    />
    <path
      fill="#543930"
      d="M95.41 19.32c-2.63-3.09-8.15-6.98-12.65-6.73c-1.24-4.2-6.28-7.28-10.89-8.14c-12.49-2.34-19.8 2.88-23.72 5.69c-.82.58-6.08 4.4-10.3 2.64c-2.64-1.1-3.06-4.92-3.06-4.92s-7.39 3.9-3.74 11.8c-2.65.43-6 1.98-7.4 5.95c-1.66 4.72-.42 8.35.43 10.05c-2.06 2.22-4.43 6.72-1.8 11.85c1.98 3.86 8.15 5 8.15 5c.47 7.33 2.38 11.65 3.32 13.38c.16.3.61.22.65-.12c.46-3.71 1.99-16.66 1.42-18.82c0 0 10.06-3.31 19.02-11.75c1.82-1.72 3.84-3.24 6.03-4.44c11.75-6.43 15.36 1.65 15.36 1.65s8.36-2.69 12.4 8.89c1.51 4.34 3.05 11.39 4.2 16.32c.08.35.57.36.67.02c.62-2.08 1.87-6.23 1.79-10.28c-.03-1.43 3.55-3.76 4.44-10.01c1.21-8.37-2.42-15.8-4.32-18.03z"
    />
    <radialGradient
      id="notoPersonShrugging9"
      cx="78.613"
      cy="107.313"
      r="32.633"
      gradientTransform="matrix(.4206 .9072 .6731 -.3121 -27.946 .247)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".699" stopColor="#6D4C41" stopOpacity="0" />
      <stop offset="1" stopColor="#6D4C41" />
    </radialGradient>
    <path
      fill="url(#notoPersonShrugging9)"
      d="M95.28 47.37c-.03-1.43 3.55-3.76 4.44-10.01c.1-.67.16-1.34.22-2.01c.43-7.52-2.78-13.98-4.53-16.03c-2.43-2.85-7.33-6.39-11.61-6.71c-.37 0-.73 0-1.07.02c0 0 .54 1.91-.06 3.57c-.77 2.14-2.79 2.88-2.79 2.88c12.21 9.55 12.54 18.75 15.4 28.29z"
    />
    <radialGradient
      id="notoPersonShrugginga"
      cx="46.799"
      cy="142.895"
      r="8.556"
      gradientTransform="matrix(.9321 .3623 .4296 -1.1051 -63.546 147.566)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".58" stopColor="#6D4C41" />
      <stop offset="1" stopColor="#6D4C41" stopOpacity="0" />
    </radialGradient>
    <path
      fill="url(#notoPersonShrugginga)"
      d="M50.61 8.44c-.94.6-1.76 1.19-2.46 1.69c-.82.58-6.08 4.4-10.3 2.64c-2.6-1.09-3.05-4.78-3.06-4.91c-.94 1.56-3.08 12.17 6.89 11.64c4.3-.23 6.47-4.26 7.65-7.61c.41-1.2 1.09-2.98 1.28-3.45z"
    />
    <radialGradient
      id="notoPersonShruggingb"
      cx="139.535"
      cy="52.551"
      r="26.303"
      gradientTransform="matrix(-.9787 -.2779 -.1526 .551 206.907 29.538)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".699" stopColor="#6D4C41" stopOpacity="0" />
      <stop offset="1" stopColor="#6D4C41" />
    </radialGradient>
    <path
      fill="url(#notoPersonShruggingb)"
      d="M70.58 4.22c6.87.99 10.53 3.98 12.17 8.37c.48 1.29 2.37 13.62-22.98 2.44c-9.43-4.16-7.43-7.73-6.45-8.23c3.84-1.94 9.56-3.68 17.26-2.58z"
    />
    <radialGradient
      id="notoPersonShruggingc"
      cx="43.364"
      cy="135.089"
      r="7.854"
      gradientTransform="matrix(.9926 -.1212 -.1482 -1.2143 15.973 184.066)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".702" stopColor="#6D4C41" stopOpacity="0" />
      <stop offset="1" stopColor="#6D4C41" />
    </radialGradient>
    <path
      fill="url(#notoPersonShruggingc)"
      d="M34.75 7.87c-.01.01-.03.02-.05.03c-.8.46-7.08 4.35-3.65 11.75l7.22.28c-7.03-5.59-3.48-12.08-3.48-12.08s-.03.01-.04.02z"
    />
    <radialGradient
      id="notoPersonShruggingd"
      cx="42.283"
      cy="121.227"
      r="14.729"
      gradientTransform="matrix(-.99 -.1409 -.1319 .9265 97.455 -77.693)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".66" stopColor="#6D4C41" stopOpacity="0" />
      <stop offset="1" stopColor="#6D4C41" />
    </radialGradient>
    <path
      fill="url(#notoPersonShruggingd)"
      d="m35.5 19.82l-4.46-.17c-.17.02-.75.15-1.06.23c-2.42.64-5.17 2.27-6.34 5.72c-1.26 3.71-.85 6.72-.15 8.67c.21.66.58 1.38.58 1.38s1.92-2.32 7.05-3.08l4.38-12.75z"
    />
    <radialGradient
      id="notoPersonShrugginge"
      cx="38.789"
      cy="107.004"
      r="15.464"
      gradientTransform="matrix(.9999 .0153 .0215 -1.4051 -3.227 192.966)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset=".598" stopColor="#6D4C41" stopOpacity="0" />
      <stop offset="1" stopColor="#6D4C41" />
    </radialGradient>
    <path
      fill="url(#notoPersonShrugginge)"
      d="M23.9 35.86c-1.92 2.17-4.3 6.79-1.52 11.82c2.1 3.79 8.06 4.82 8.06 4.82c0 .02 1.19.22 1.78.15l-1.08-20.07c-2.75.34-5.3 1.48-6.86 2.88c.01.03-.4.37-.38.4z"
    />
  </svg>
)

export const Cross = ({ fill, width = "24", height = "24" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
  >
    <g strokeWidth="2">
      <path
        fill={fill}
        stroke={fill}
        d="M11 2h2v7h-2zm0 13h2v7h-2zm4-4h7v2h-7zM2 11h7v2H2z"
      />
    </g>
  </svg>
)

export const ColorsCircles3 = ({ width = "24", height = "24" }) => (
  <svg
    height={height}
    width={width}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <g>
        {" "}
        <path
          style={{ fill: "#F0C419" }}
          d="M300.138,344.276c0,82.882-67.187,150.069-150.069,150.069S0,427.158,0,344.276 s67.187-150.069,150.069-150.069S300.138,261.394,300.138,344.276"
        ></path>{" "}
        <path
          style={{ fill: "#E64C3C" }}
          d="M406.069,167.724c0,82.882-67.187,150.069-150.069,150.069s-150.069-67.187-150.069-150.069 S173.118,17.655,256,17.655S406.069,84.842,406.069,167.724"
        ></path>{" "}
        <path
          style={{ fill: "#13A085" }}
          d="M512,344.276c0,82.882-67.187,150.069-150.069,150.069s-150.069-67.187-150.069-150.069 s67.187-150.069,150.069-150.069S512,261.394,512,344.276"
        ></path>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const SettingsCircle = ({
  width = "24",
  height = "24",
  fill,
}) => (
  <svg
    height={height}
    width={width}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <g id="Layer_1">
        {" "}
        <g>
          {" "}
          <circle
            style={{ fill: fill }}
            cx="32"
            cy="32"
            r="32"
          ></circle>{" "}
        </g>{" "}
        <g>
          {" "}
          <path
            style={{ fill: "#4f5d73" }}
            d="M32,52c-1.1,0-2-0.9-2-2V18c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2v32C34,51.1,33.1,52,32,52L32,52z"
          ></path>{" "}
        </g>{" "}
        <g>
          {" "}
          <path
            style={{ fill: "#4f5d73" }}
            d="M46,52c-1.1,0-2-0.9-2-2V18c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2v32C48,51.1,47.1,52,46,52L46,52z"
          ></path>{" "}
        </g>{" "}
        <g>
          {" "}
          <path
            style={{ fill: "#4f5d73" }}
            d="M18,52c-1.1,0-2-0.9-2-2V18c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2v32C20,51.1,19.1,52,18,52L18,52z"
          ></path>{" "}
        </g>{" "}
        <g style={{ opacity: 0.2 }}>
          {" "}
          <circle
            style={{ fill: "#231f20" }}
            cx="45.9"
            cy="38"
            r="4"
          ></circle>{" "}
        </g>{" "}
        <g style={{ opacity: 0.2 }}>
          {" "}
          <circle
            style={{ fill: "#231f20" }}
            cx="32"
            cy="27"
            r="4"
          ></circle>{" "}
        </g>{" "}
        <g style={{ opacity: 0.2 }}>
          {" "}
          <circle
            style={{ fill: "#231f20" }}
            cx="18"
            cy="44"
            r="4"
          ></circle>{" "}
        </g>{" "}
        <g>
          {" "}
          <circle
            style={{ fill: "ffffff" }}
            cx="45.9"
            cy="36"
            r="4"
          ></circle>{" "}
        </g>{" "}
        <g>
          {" "}
          <circle
            style={{ fill: "ffffff" }}
            cx="32"
            cy="25"
            r="4"
          ></circle>{" "}
        </g>{" "}
        <g>
          {" "}
          <circle
            style={{ fill: "ffffff" }}
            cx="18"
            cy="42"
            r="4"
          ></circle>{" "}
        </g>{" "}
      </g>{" "}
      <g id="Layer_2"> </g>{" "}
    </g>
  </svg>
)

export const LightBulb = ({ width = "24", height = "24", fill }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 1024 1024"
    className="icon"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M513.311597 95.397443c-156.598141 0-253.554962 137.570256-253.554962 265.040908 0 105.370087 44.014782 155.726815 82.912186 200.192106l7.377094 8.41429c20.519686 23.753116 25.437407 101.224375 22.39442 158.053082a25.298159 25.298159 0 0 0 6.79655 18.445294c4.725231 4.920793 11.19721 7.767194 18.057242 7.767194h8.122482v115.854673c0 13.722111 11.134753 24.853792 24.853793 24.853792h58.187403v9.967524c0 13.719039 11.130657 24.853792 24.853792 24.853792s24.853792-11.134753 24.853792-24.853792v-9.967524h58.283649c13.722111 0 24.853792-11.131681 24.853792-24.853792V753.310317h8.155247c6.860032 0 13.332011-2.846401 18.057241-7.767194a25.293039 25.293039 0 0 0 6.796551-18.445294c-3.041963-56.828707 1.875758-134.299966 22.39442-158.053082l7.442622-8.546371c38.831875-44.398739 82.845633-94.752396 82.845634-200.060025 0.001024-127.470651-96.954773-265.040907-253.682948-265.040908z"
        fill="#27323A"
      ></path>
      <path
        d="M571.595245 844.311197H455.124194v-91.00088h116.471051v91.00088z"
        fill={fill}
      ></path>
      <path
        d="M646.740237 527.812885l-7.638184 8.705073c-30.355128 35.176604-35.404931 104.432208-35.404931 155.239445 0 4.467212 0.12901 7.896204 0.195562 11.843282H422.827779c0.066553-3.947078 0.195562-7.37607 0.195562-11.843282 0-50.87379-5.049802-120.063865-35.372166-155.239445 0-0.032764-7.571632-8.639544-7.571632-8.639544-36.310045-41.552338-70.614299-80.774313-70.614299-167.441087 0-105.85336 76.244645-215.333323 203.847377-215.333323 127.731742 0 203.976387 109.478938 203.976387 215.333323-0.001024 86.601245-34.238725 125.824244-70.548771 167.375558z"
        fill="#F4CE73"
      ></path>
      <path
        d="M460.237477 205.622794c3.496568 8.476747-0.517062 18.186251-8.993808 21.68282-42.134929 17.473627-61.196602 49.383013-69.739901 73.069576-13.917673 38.642456-10.163086 84.691699 10.160014 123.168285 4.27165 8.09279 1.166205 18.123794-6.925561 22.39442-8.088694 4.27165-18.123794 1.166205-22.39442-6.92556-24.916249-47.311693-29.317932-101.907306-12.035771-149.897836 15.336778-42.361208 46.665621-75.207449 88.247652-92.426128 8.479818-3.492473 18.189323 0.520134 21.681795 8.934423z"
        fill="#FFFFFF"
      ></path>
    </g>
  </svg>
)

export const MenuColored = ({
  width = "24",
  height = "24",
  stroke = "red",
}) => (
  <svg
    width={width}
    height={height}
    fill="#000000"
    viewBox="0 0 24 24"
    id="menu-alt-2"
    data-name="Line Color"
    xmlns="http://www.w3.org/2000/svg"
    className="icon line-color"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        id="secondary"
        d="M21,3H14v7h7ZM10,14H3v7h7Z"
        style={{
          fill: "none",
          stroke: stroke,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
        }}
      ></path>
      <path
        id="primary"
        d="M10,10H3V3h7Zm11,4H14v7h7Z"
        style={{
          fill: "none",
          stroke: "#FFFFFF",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
        }}
      ></path>
    </g>
  </svg>
)

export const PencilColored = ({ width = "24", height = "24" }) => (
  <svg
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512.001 512.001"
    xmlSpace="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        style={{ fill: "#FFBD42" }}
        d="M33.052,356.136l-0.822,0.822l0,0L0.613,485.716c-1.77,7.209,0.355,14.819,5.604,20.068 l88.242-88.242L33.052,356.136z"
      ></path>{" "}
      <path
        style={{ fill: "#30767A" }}
        d="M502.599,86.817L425.182,9.402c-12.536-12.536-32.86-12.536-45.396,0L311.18,78.008l-10.078,10.078 L32.23,356.957l0,0L0.613,485.716c-1.77,7.209,0.355,14.819,5.604,20.068c5.249,5.249,12.858,7.374,20.068,5.604l128.759-31.617l0,0 l268.873-268.873l10.078-10.078l68.606-68.606C515.135,119.677,515.135,99.353,502.599,86.817z"
      ></path>{" "}
      <path
        style={{ fill: "#007066" }}
        d="M425.182,9.402c-12.536-12.536-32.86-12.536-45.396,0L311.18,78.008l-10.078,10.078L32.23,356.957 l0,0L0.613,485.716c-1.77,7.209,0.355,14.819,5.604,20.068L463.891,48.11L425.182,9.402z"
      ></path>{" "}
      <path
        style={{ fill: "#4AB6BF" }}
        d="M425.182,9.402c-12.536-12.536-32.86-12.536-45.396,0L311.18,78.008l-10.078,10.078L32.23,356.957 l0,0L0.613,485.716c-1.77,7.209,0.355,14.819,5.604,20.068L463.891,48.11L425.182,9.402z"
      ></path>{" "}
      <path
        style={{ fill: "#940009" }}
        d="M466.265,168.547l36.334-36.334c12.536-12.536,12.536-32.86,0-45.396L425.182,9.402 c-12.536-12.536-32.86-12.536-45.396,0l-36.334,36.334L466.265,168.547z"
      ></path>{" "}
      <path
        style={{ fill: "#FF0029" }}
        d="M463.891,48.11L425.182,9.402c-12.536-12.536-32.86-12.536-45.396,0l-36.334,36.334l61.407,61.407 L463.891,48.11z"
      ></path>{" "}
      <path
        style={{ fill: "#F7DC4D" }}
        d="M33.052,356.136l-0.822,0.822l0,0L0.613,485.716c-1.77,7.209,0.355,14.819,5.604,20.068 c5.249,5.249,12.858,7.374,20.068,5.604l128.759-31.617l0,0l0.822-0.822L33.052,356.136z"
      ></path>{" "}
      <rect
        x="297.713"
        y="90.415"
        transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 566.3668 489.469)"
        style={{ fill: "#FF9800" }}
        width="173.685"
        height="74.042"
      ></rect>{" "}
      <polygon
        style={{ fill: "#F7DC4D" }}
        points="410.735,101.265 349.328,39.86 311.18,78.007 301.103,88.085 296.972,92.217 358.378,153.622 "
      ></polygon>{" "}
      <path
        style={{ fill: "#2D2B27" }}
        d="M11.138,442.855l-10.524,42.86c-1.77,7.209,0.355,14.819,5.604,20.068 c5.249,5.249,12.858,7.374,20.068,5.604l42.86-10.525L11.138,442.855z"
      ></path>{" "}
      <path
        style={{ fill: "#403E3B" }}
        d="M11.138,442.855l-10.524,42.86c-1.77,7.209,0.355,14.819,5.604,20.068l33.925-33.925L11.138,442.855z "
      ></path>{" "}
    </g>
  </svg>
)

export const HeartRed = ({ width = "24", height = "24" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M16.1315 3.71436C14.4172 3.71436 12.9029 4.57721 12 5.8915C11.0972 4.57721 9.58289 3.71436 7.86861 3.71436C5.10289 3.71436 2.85718 5.96007 2.85718 8.72578C2.85718 14.8344 12 20.3258 12 20.3258C12 20.3258 21.1429 14.8344 21.1429 8.72578C21.1429 5.96007 18.8972 3.71436 16.1315 3.71436Z"
        fill="url(#paint0_radial)"
      ></path>{" "}
      <path
        opacity="0.5"
        d="M18.2056 4.16016C20.9485 8.53158 18.4228 14.2687 15.3885 15.8973C12.0399 17.6973 9.74847 16.8516 5.00562 14.1602C7.70847 17.743 11.9999 20.3202 11.9999 20.3202C11.9999 20.3202 21.1428 14.8287 21.1428 8.72016C21.1428 6.6973 19.937 4.94873 18.2056 4.16016Z"
        fill="url(#paint1_radial)"
      ></path>{" "}
      <path
        opacity="0.5"
        d="M16.1315 3.71436C14.4172 3.71436 12.9029 4.57721 12 5.8915C11.0972 4.57721 9.58289 3.71436 7.86861 3.71436C5.10289 3.71436 2.85718 5.96007 2.85718 8.72578C2.85718 14.8344 12 20.3258 12 20.3258C12 20.3258 21.1429 14.8344 21.1429 8.72578C21.1429 5.96007 18.8972 3.71436 16.1315 3.71436Z"
        fill="url(#paint2_radial)"
      ></path>{" "}
      <path
        opacity="0.5"
        d="M16.1315 3.71436C14.4172 3.71436 12.9029 4.57721 12 5.8915C11.0972 4.57721 9.58289 3.71436 7.86861 3.71436C5.10289 3.71436 2.85718 5.96007 2.85718 8.72578C2.85718 14.8344 12 20.3258 12 20.3258C12 20.3258 21.1429 14.8344 21.1429 8.72578C21.1429 5.96007 18.8972 3.71436 16.1315 3.71436Z"
        fill="url(#paint3_radial)"
      ></path>{" "}
      <path
        opacity="0.24"
        d="M10.7486 5.74883C11.2514 6.93169 10.1371 8.5374 8.25714 9.33169C6.37714 10.126 4.45143 9.8174 3.94857 8.64026C3.44571 7.46312 4.56 5.85169 6.44 5.0574C8.32 4.26312 10.2457 4.56597 10.7486 5.74883Z"
        fill="url(#paint4_radial)"
      ></path>{" "}
      <path
        opacity="0.24"
        d="M16.8742 4.78885C17.5885 5.57742 17.1485 7.13742 15.8971 8.26885C14.6456 9.40028 13.0513 9.68028 12.3371 8.8917C11.6228 8.10313 12.0628 6.54313 13.3142 5.41171C14.5656 4.28028 16.1599 4.00028 16.8742 4.78885Z"
        fill="url(#paint5_radial)"
      ></path>{" "}
      <path
        opacity="0.32"
        d="M16.2229 5.04578C18.7372 5.90293 21.1372 9.61721 17.0801 14.2458C14.6515 17.0172 12.0001 18.4172 8.62866 17.8686C10.4515 19.3886 12.0058 20.3258 12.0058 20.3258C12.0058 20.3258 21.1487 14.8344 21.1487 8.72578C21.1429 5.96007 18.8972 3.71436 16.1315 3.71436C14.4172 3.71436 12.9029 4.57721 12.0001 5.8915C12.0001 5.8915 14.3829 4.41721 16.2229 5.04578Z"
        fill="url(#paint6_linear)"
      ></path>{" "}
      <defs>
        {" "}
        <radialGradient
          id="paint0_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.38479 8.34769) rotate(-29.408) scale(14.3064 11.3486)"
        >
          {" "}
          <stop offset="0.2479" stopColor="#FF0000"></stop>{" "}
          <stop offset="0.8639" stopColor="#C20000"></stop>{" "}
        </radialGradient>{" "}
        <radialGradient
          id="paint1_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.7385 7.47018) rotate(-29.408) scale(12.3173 9.77078)"
        >
          {" "}
          <stop offset="0.2479" stopColor="#FF0000"></stop>{" "}
          <stop offset="1" stopColor="#C20000"></stop>{" "}
        </radialGradient>{" "}
        <radialGradient
          id="paint2_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.38479 8.34769) rotate(-29.408) scale(14.3064 11.3486)"
        >
          {" "}
          <stop stopColor="white" stopOpacity="0.25"></stop>{" "}
          <stop offset="1" stopColor="white" stopOpacity="0"></stop>{" "}
        </radialGradient>{" "}
        <radialGradient
          id="paint3_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.5277 13.2044) rotate(-26.296) scale(10.4431 5.16038)"
        >
          {" "}
          <stop stopColor="#BD2719" stopOpacity="0.25"></stop>{" "}
          <stop offset="1" stopColor="#BD2719" stopOpacity="0"></stop>{" "}
        </radialGradient>{" "}
        <radialGradient
          id="paint4_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.34746 7.19453) rotate(-21.6908) scale(3.71252 2.30616)"
        >
          {" "}
          <stop stopColor="white"></stop>{" "}
          <stop offset="1" stopColor="white" stopOpacity="0"></stop>{" "}
        </radialGradient>{" "}
        <radialGradient
          id="paint5_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.6004 6.84619) rotate(-40.7634) scale(3.07376 1.9095)"
        >
          {" "}
          <stop stopColor="white"></stop>{" "}
          <stop offset="1" stopColor="white" stopOpacity="0"></stop>{" "}
        </radialGradient>{" "}
        <linearGradient
          id="paint6_linear"
          x1="13.8868"
          y1="26.8498"
          x2="15.6583"
          y2="2.96408"
          gradientUnits="userSpaceOnUse"
        >
          {" "}
          <stop stopColor="#860805"></stop>{" "}
          <stop offset="1" stopColor="#BD2719" stopOpacity="0"></stop>{" "}
        </linearGradient>{" "}
      </defs>{" "}
    </g>
  </svg>
)

export const CopyrightSolid = ({
  width = "24",
  height = "24",
  fill,
}) => (
  <svg
    fill={fill}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 15.90625 10 C 12.582031 10 9.90625 12.675781 9.90625 16 C 9.90625 19.324219 12.582031 22 15.90625 22 C 18.304688 22 20.355469 20.5625 21.3125 18.53125 L 19.5 17.6875 C 18.855469 19.058594 17.507813 20 15.90625 20 C 13.628906 20 11.90625 18.277344 11.90625 16 C 11.90625 13.722656 13.628906 12 15.90625 12 C 17.507813 12 18.855469 12.941406 19.5 14.3125 L 21.3125 13.46875 C 20.355469 11.4375 18.304688 10 15.90625 10 Z"></path>
    </g>
  </svg>
)

export const GitHubSolid = ({
  width = "24",
  height = "24",
  fill,
  onClick,
  title,
  desc,
}) => (
  <svg
    onClick={onClick}
    width={width}
    height={height}
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill={fill}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <title>{title}</title> <desc>{desc}</desc> <defs> </defs>{" "}
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        {" "}
        <g
          id="Dribbble-Light-Preview"
          transform="translate(-140.000000, -7559.000000)"
          fill={fill}
        >
          {" "}
          <g id="icons" transform="translate(56.000000, 160.000000)">
            {" "}
            <path
              d="M94,7399 C99.523,7399 104,7403.59 104,7409.253 C104,7413.782 101.138,7417.624 97.167,7418.981 C96.66,7419.082 96.48,7418.762 96.48,7418.489 C96.48,7418.151 96.492,7417.047 96.492,7415.675 C96.492,7414.719 96.172,7414.095 95.813,7413.777 C98.04,7413.523 100.38,7412.656 100.38,7408.718 C100.38,7407.598 99.992,7406.684 99.35,7405.966 C99.454,7405.707 99.797,7404.664 99.252,7403.252 C99.252,7403.252 98.414,7402.977 96.505,7404.303 C95.706,7404.076 94.85,7403.962 94,7403.958 C93.15,7403.962 92.295,7404.076 91.497,7404.303 C89.586,7402.977 88.746,7403.252 88.746,7403.252 C88.203,7404.664 88.546,7405.707 88.649,7405.966 C88.01,7406.684 87.619,7407.598 87.619,7408.718 C87.619,7412.646 89.954,7413.526 92.175,7413.785 C91.889,7414.041 91.63,7414.493 91.54,7415.156 C90.97,7415.418 89.522,7415.871 88.63,7414.304 C88.63,7414.304 88.101,7413.319 87.097,7413.247 C87.097,7413.247 86.122,7413.234 87.029,7413.87 C87.029,7413.87 87.684,7414.185 88.139,7415.37 C88.139,7415.37 88.726,7417.2 91.508,7416.58 C91.513,7417.437 91.522,7418.245 91.522,7418.489 C91.522,7418.76 91.338,7419.077 90.839,7418.982 C86.865,7417.627 84,7413.783 84,7409.253 C84,7403.59 88.478,7399 94,7399"
              id="github-[#142]"
            >
              {" "}
            </path>{" "}
          </g>{" "}
        </g>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const NotFoundSocket = ({ width = "24", height = "24" }) => (
  <svg
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <rect
        x="10.723"
        y="35.812"
        style={{ fill: "#A7A9AC" }}
        width="257.34"
        height="257.34"
      ></rect>{" "}
      <g>
        {" "}
        <path
          style={{ fill: "#EFEFEF" }}
          d="M136.712,78.702h5.361c47.375,0,85.78,38.405,85.78,85.78l0,0c0,47.375-38.405,85.78-85.78,85.78 h-5.361c-47.375,0-85.78-38.405-85.78-85.78l0,0C50.932,117.108,89.337,78.702,136.712,78.702z"
        ></path>{" "}
        <path
          style={{ fill: "#EFEFEF" }}
          d="M377.253,155.932h-42.89V67.757c0-11.844,9.601-21.445,21.445-21.445l0,0 c11.844,0,21.445,9.601,21.445,21.445V155.932z"
        ></path>{" "}
        <path
          style={{ fill: "#EFEFEF" }}
          d="M475.186,155.932h-42.89V67.757c0-11.844,9.601-21.445,21.445-21.445l0,0 c11.844,0,21.445,9.601,21.445,21.445V155.932z"
        ></path>{" "}
      </g>{" "}
      <rect
        x="383.33"
        y="288.415"
        style={{ fill: "#A7A9AC" }}
        width="42.89"
        height="187.773"
      ></rect>{" "}
      <path
        style={{ fill: "#FFDE17" }}
        d="M485.497,155.932H324.053c-8.715,0-15.78,7.065-15.78,15.78v11.329c0,8.715,7.065,15.78,15.78,15.78 h8.345v34.848c0,39.972,32.405,72.377,72.377,72.377l0,0c39.972,0,72.377-32.405,72.377-72.377v-34.848h8.345 c8.715,0,15.78-7.065,15.78-15.78v-11.33C501.277,162.997,494.212,155.932,485.497,155.932z"
      ></path>{" "}
      <g>
        {" "}
        <path
          style={{ fill: "#231F20" }}
          d="M268.063,25.089H10.723C4.802,25.089,0,29.891,0,35.812v257.34c0,5.921,4.802,10.723,10.723,10.723 h257.34c5.921,0,10.723-4.802,10.723-10.723V35.812C278.785,29.89,273.984,25.089,268.063,25.089z M257.34,282.429H21.445V46.534 H257.34V282.429z"
        ></path>{" "}
        <path
          style={{ fill: "#231F20" }}
          d="M136.712,260.984h5.361c53.212,0,96.503-43.291,96.503-96.503s-43.291-96.503-96.503-96.503h-5.361 c-53.212,0-96.503,43.291-96.503,96.504C40.209,217.694,83.501,260.984,136.712,260.984z M128.67,89.861v13.405 c0,5.921,4.802,10.723,10.723,10.723s10.723-4.802,10.723-10.723V89.861c37.618,4.026,67.016,35.953,67.016,74.622 c0,38.669-29.398,70.594-67.016,74.62v-13.404c0-5.921-4.802-10.723-10.723-10.723s-10.723,4.802-10.723,10.723v13.404 c-37.618-4.026-67.016-35.953-67.016-74.621S91.052,93.887,128.67,89.861z"
        ></path>{" "}
        <path
          style={{ fill: "#231F20" }}
          d="M104.633,178.546c5.921,0,10.723-4.802,10.723-10.723v-6.683c0-5.921-4.802-10.723-10.723-10.723 s-10.723,4.802-10.723,10.723v6.683C93.911,173.746,98.713,178.546,104.633,178.546z"
        ></path>{" "}
        <path
          style={{ fill: "#231F20" }}
          d="M180.942,178.546c5.921,0,10.723-4.802,10.723-10.723v-6.683c0-5.921-4.802-10.723-10.723-10.723 s-10.723,4.802-10.723,10.723v6.683C170.22,173.746,175.021,178.546,180.942,178.546z"
        ></path>{" "}
        <path
          style={{ fill: "#231F20" }}
          d="M485.909,145.219V67.757c0-17.737-14.43-32.168-32.169-32.168c-17.737,0-32.166,14.43-32.166,32.168 v77.451h-33.598V67.757c0-17.737-14.43-32.168-32.169-32.168c-17.737,0-32.166,14.43-32.166,32.168v77.462 c-14.424,0.222-26.091,12.017-26.091,26.492v11.329c0,13.813,10.621,25.191,24.126,26.397v24.232 c0,34.421,21.04,64.019,50.932,76.617v165.903c0,5.921,4.802,10.723,10.723,10.723h42.89c5.921,0,10.723-4.802,10.723-10.723 V310.286c29.892-12.598,50.932-42.195,50.932-76.617v-24.232C501.379,208.233,512,196.854,512,183.041v-11.33 C512,157.235,500.333,145.441,485.909,145.219z M443.019,67.757c0-5.912,4.81-10.723,10.723-10.723s10.723,4.81,10.723,10.723 v77.451h-21.445V67.757z M345.086,67.757c0-5.912,4.81-10.723,10.723-10.723s10.723,4.81,10.723,10.723v77.451h-21.445V67.757z M415.497,465.467h-21.445V316.053c3.514,0.455,7.088,0.715,10.723,0.715s7.209-0.261,10.723-0.715V465.467z M490.555,183.041 c0,2.789-2.269,5.058-5.058,5.058h-8.345h-35.92c-5.921,0-10.723,4.802-10.723,10.723s4.802,10.723,10.723,10.723h25.198v24.126 c0,33.997-27.658,61.654-61.654,61.654s-61.654-27.658-61.654-61.654v-34.848c0-5.921-4.802-10.723-10.723-10.723h-8.345 c-2.789,0-5.058-2.269-5.058-5.058v-11.33c0-2.789,2.269-5.058,5.058-5.058h161.445c2.789,0,5.058,2.269,5.058,5.058 L490.555,183.041L490.555,183.041z"
        ></path>{" "}
        <path
          style={{ fill: "#231F20" }}
          d="M399.235,188.098h-1.072c-5.921,0-10.723,4.802-10.723,10.723s4.802,10.723,10.723,10.723h1.072 c5.921,0,10.723-4.802,10.723-10.723S405.156,188.098,399.235,188.098z"
        ></path>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const RecentSolid = ({ size, sx, fill }) => (
  <SvgIcon fontSize={size} sx={sx} viewBox="0 0 32 32">
    <path
      fill={fill}
      d="M20.59 22L15 16.41V7h2v8.58l5 5.01L20.59 22z"
    />
    <path
      fill={fill}
      d="M16 2A13.94 13.94 0 0 0 6 6.23V2H4v8h8V8H7.08A12 12 0 1 1 4 16H2A14 14 0 1 0 16 2Z"
    />
  </SvgIcon>
)

export const HTMLLogo = ({ width = "24", height = "24" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M6 28L4 3H28L26 28L16 31L6 28Z"
        fill="#E44D26"
      ></path>{" "}
      <path d="M26 5H16V29.5L24 27L26 5Z" fill="#F16529"></path>{" "}
      <path
        d="M9.5 17.5L8.5 8H24L23.5 11H11.5L12 14.5H23L22 24L16 26L10 24L9.5 19H12.5L13 21.5L16 22.5L19 21.5L19.5 17.5H9.5Z"
        fill="white"
      ></path>{" "}
    </g>
  </svg>
)

export const SASSLogo = ({ width = "24", height = "24" }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Sass"
    role="img"
    viewBox="0 0 512 512"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <rect width="512" height="512" rx="15%" fill="#a2155c"></rect>
      <path
        d="M258,88c-96,33-158,100-152,140s66,72,93,93h0c-35,18-79,45-78,80,2,48,54,33,76,19s44-53,30-94c31-8,58,2,66,8,31,22,15,47,4,51s-4,6,3,4,22-12,22-29c0-43-46-63-103-48-33-35-78-51-76-89,1-14,6-50,95-95s152-27,144,14c-12,62-120,104-158,68-2-4-9-7-5,4,20,50,182,27,189-79C410,79,329,64,258,88ZM172,408c-25,8-24-8-23-14,3-17,17-38,59-59C220,373,193,402,172,408Z"
        fill="#ffffff"
      ></path>
    </g>
  </svg>
)

export const FolderCodeSolid = ({
  width = "30",
  height = "30",
  fill,
}) => (
  <svg
    width={width}
    height={height}
    fill="#888686"
    viewBox="0 0 24 24"
    id="folder-code"
    data-name="Flat Color"
    xmlns="http://www.w3.org/2000/svg"
    className="icon flat-color"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        id="primary"
        d="M20,6H13.41L11,3.59A2,2,0,0,0,9.59,3H4A2,2,0,0,0,2,5V19a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V8A2,2,0,0,0,20,6Z"
        style={{ fill: fill }}
      ></path>
    </g>
  </svg>
)

export const FolderFilled = ({
  width = "30",
  height = "30",
  fill,
  _fill,
  tags,
}) => (
  <svg
    width={width}
    height={height}
    fill="#000000"
    viewBox="0 0 24 24"
    id="folder-code-3"
    data-name="Flat Color"
    xmlns="http://www.w3.org/2000/svg"
    className="icon flat-color"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        id="secondary"
        d="M19.71,4.29l-2-2A1,1,0,0,0,17,2H6A2,2,0,0,0,4,4v7a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V5A1,1,0,0,0,19.71,4.29Z"
        style={{ fill: _fill }}
      ></path>
      <path
        id="primary"
        d="M17,4a1,1,0,0,0,1,1h2a1,1,0,0,0-.28-.71l-2-2A1,1,0,0,0,17,2Z"
        style={{ fill: fill }}
      ></path>
      <path
        id="primary-2"
        data-name="primary"
        d="M20,10H11.4L9.7,8.29A1,1,0,0,0,9,8H4a2,2,0,0,0-2,2V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V12A2,2,0,0,0,20,10Z"
        style={{ fill: fill }}
      ></path>
      <path
        id="secondary-2"
        data-name="secondary"
        d="M11,20a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42L11.59,17l-1.3-1.29a1,1,0,0,1,1.42-1.42l2,2a1,1,0,0,1,0,1.42l-2,2A1,1,0,0,1,11,20Zm-3.29-.29a1,1,0,0,0,0-1.42L6.41,17l1.3-1.29a1,1,0,0,0-1.42-1.42l-2,2a1,1,0,0,0,0,1.42l2,2a1,1,0,0,0,1.42,0Z"
        style={{ fill: tags }}
      ></path>
    </g>
  </svg>
)

export const Snippet = ({
  width = "30",
  height = "30",
  fill,
  _fill,
}) => (
  <svg
    width={width}
    height={height}
    fill="#000000"
    viewBox="0 0 24 24"
    id="file-code-3"
    data-name="Flat Color"
    xmlns="http://www.w3.org/2000/svg"
    className="icon flat-color"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        id="primary"
        d="M2,20a2,2,0,0,0,2,2h6.81a6,6,0,0,1,4-8.88,5.91,5.91,0,0,1,3.17.23V5a1,1,0,0,0-.29-.7l-2-2A1,1,0,0,0,15,2H4A2,2,0,0,0,2,4Z"
        style={{ fill: _fill }}
      ></path>
      <path
        id="secondary"
        d="M19,22a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42L19.59,19l-1.3-1.29a1,1,0,0,1,1.42-1.42l2,2a1,1,0,0,1,0,1.42l-2,2A1,1,0,0,1,19,22Zm-3.29-.29a1,1,0,0,0,0-1.42L14.41,19l1.3-1.29a1,1,0,0,0-1.42-1.42l-2,2a1,1,0,0,0,0,1.42l2,2a1,1,0,0,0,1.42,0ZM15,4a1,1,0,0,0,1,1h2a1,1,0,0,0-.28-.71l-2-2A1,1,0,0,0,15,2Zm-4,8a1,1,0,0,0-1-1H6a1,1,0,0,0,0,2h4A1,1,0,0,0,11,12Zm4-4a1,1,0,0,0-1-1H6A1,1,0,0,0,6,9h8A1,1,0,0,0,15,8Z"
        style={{ fill: fill }}
      ></path>
    </g>
  </svg>
)

export const FolderAltSolid = ({
  width = "30",
  height = "30",
  fill,
}) => (
  <svg
    width={width}
    height={height}
    fill="#000000"
    viewBox="0 0 24 24"
    id="folder-alt"
    data-name="Flat Color"
    xmlns="http://www.w3.org/2000/svg"
    className="icon flat-color"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        id="primary"
        d="M17,6H11.83L9.4,3.56A2.05,2.05,0,0,0,8,3H4A2,2,0,0,0,2,5V20a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V8A2,2,0,0,0,17,6Z"
        style={{ fill: fill }}
      ></path>
      <path
        id="secondary"
        d="M21.81,10.42A1,1,0,0,0,21,10H7a1,1,0,0,0-.91.59l-4,9A1,1,0,0,0,3,21H18a1,1,0,0,0,.95-.68l3-9A1,1,0,0,0,21.81,10.42Z"
        style={{ fill: "#666" }}
      ></path>
    </g>
  </svg>
)

export const FolderDuotone = ({
  width = "30",
  height = "30",
  fill,
  body,
}) => (
  <svg
    viewBox="-4 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    width={width}
    height={height}
    className="folder-icon"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M51.48,15.46A4.52,4.52,0,0,1,56,20V51a4.52,4.52,0,0,1-4.52,4.52h-47A4.52,4.52,0,0,1,0,51H0V13A4.52,4.52,0,0,1,4.52,8.52H16c3.82,0,4.23,1.14,6.74,4.45,2.07,2.74,7.11,2.49,10.39,2.49Z"
        fill={fill}
      ></path>
      <path
        d="M51.48,18.12H9.24a4.52,4.52,0,0,0-4.52,4.52v2.84L9.19,19H51.54L56,25.49V22.64A4.52,4.52,0,0,0,51.48,18.12Z"
        fill="#000"
      ></path>
      <path
        d="M4.57,55.48H51.48A4.52,4.52,0,0,0,56,51V23.48A4.52,4.52,0,0,0,51.48,19H9.25a4.52,4.52,0,0,0-4.52,4.52V51a4.65,4.65,0,0,1-.06.72,2.33,2.33,0,0,1-4.6,0A4.5,4.5,0,0,0,4.57,55.48Z"
        fill={body}
      ></path>
    </g>
  </svg>
)

export const FolderSearch = ({ width = "30", height = "30" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 -3.66 65.015 65.015"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <g
        id="Group_99"
        data-name="Group 99"
        transform="translate(-107.858 -217.309)"
      >
        {" "}
        <g id="Group_97" data-name="Group 97">
          {" "}
          <path
            id="Path_247"
            data-name="Path 247"
            d="M158.251,220.766H133.473l-5.725-3.457H114.226a2.911,2.911,0,0,0-2.912,2.912v30.934a2.911,2.911,0,0,0,2.912,2.912h44.025a2.911,2.911,0,0,0,2.911-2.912V223.676A2.911,2.911,0,0,0,158.251,220.766Z"
            fill="#f7971d"
          ></path>{" "}
          <path
            id="Path_248"
            data-name="Path 248"
            d="M161.162,242.6V227.133a2.914,2.914,0,0,0-2.911-2.914H114.226a2.914,2.914,0,0,0-2.912,2.914V242.6Z"
            fill="#dce2e9"
          ></path>{" "}
          <path
            id="Path_249"
            data-name="Path 249"
            d="M158.251,220.766H133.473l-5.725-3.457H114.226a2.911,2.911,0,0,0-2.912,2.912V221.6a2.911,2.911,0,0,1,2.912-2.912h13.522l5.725,3.455h24.778a2.913,2.913,0,0,1,2.911,2.912v-1.383A2.911,2.911,0,0,0,158.251,220.766Z"
            fill="#ffc52f"
            opacity="0.5"
            style={{ mixBlendMode: "screen", isolation: "isolate" }}
          ></path>{" "}
          <path
            id="Path_250"
            data-name="Path 250"
            d="M161.707,226.293H110.771a2.913,2.913,0,0,0-2.913,2.913l3.456,30.933a2.911,2.911,0,0,0,2.912,2.912h44.025a2.911,2.911,0,0,0,2.911-2.912l3.455-30.933A2.912,2.912,0,0,0,161.707,226.293Z"
            fill="#ffc52f"
          ></path>{" "}
          <path
            id="Path_251"
            data-name="Path 251"
            d="M110.771,227.676h50.936a2.911,2.911,0,0,1,2.83,2.254l.08-.724a2.912,2.912,0,0,0-2.91-2.913H110.771a2.913,2.913,0,0,0-2.913,2.913l.081.724A2.911,2.911,0,0,1,110.771,227.676Z"
            fill="#ffc52f"
            opacity="0.5"
            style={{ mixBlendMode: "screen", isolation: "isolate" }}
          ></path>{" "}
        </g>{" "}
        <path
          id="Path_252"
          data-name="Path 252"
          d="M161.162,260.139l.592-5.3a14.7,14.7,0,1,0-27.687,8.211h24.184A2.911,2.911,0,0,0,161.162,260.139Z"
          fill="#8c93a1"
          opacity="0.6"
          style={{ mixBlendMode: "multiply", isolation: "isolate" }}
        ></path>{" "}
        <g id="Group_98" data-name="Group 98">
          {" "}
          <rect
            id="Rectangle_36"
            data-name="Rectangle 36"
            width="4.156"
            height="12.401"
            transform="translate(157.7 262.706) rotate(-45)"
            fill="#dce2e9"
          ></rect>{" "}
          <path
            id="Path_253"
            data-name="Path 253"
            d="M165.421,252.721a14.7,14.7,0,1,1-14.7-14.7A14.7,14.7,0,0,1,165.421,252.721Z"
            fill="#dce2e9"
          ></path>{" "}
          <path
            id="Path_254"
            data-name="Path 254"
            d="M161.682,252.721a10.964,10.964,0,1,1-10.964-10.965A10.965,10.965,0,0,1,161.682,252.721Z"
            fill="#8c93a1"
          ></path>{" "}
          <path
            id="Path_255"
            data-name="Path 255"
            d="M150.718,262.616a9.895,9.895,0,1,1,9.894-9.9A9.9,9.9,0,0,1,150.718,262.616Z"
            fill="#5a6271"
            opacity="0.6"
          ></path>{" "}
          <path
            id="Path_256"
            data-name="Path 256"
            d="M141.833,253.735a9.895,9.895,0,0,1,16.368-7.484A9.892,9.892,0,1,0,144.247,260.2,9.843,9.843,0,0,1,141.833,253.735Z"
            fill="#5a6271"
            opacity="0.6"
          ></path>{" "}
          <path
            id="Path_257"
            data-name="Path 257"
            d="M150.718,257.606a4.885,4.885,0,1,1,4.885-4.885A4.888,4.888,0,0,1,150.718,257.606Z"
            fill="#5a6271"
          ></path>{" "}
          <path
            id="Path_258"
            data-name="Path 258"
            d="M147.01,258.946a1.9,1.9,0,1,1,1.9-1.9A1.9,1.9,0,0,1,147.01,258.946Z"
            fill="#f3f3f3"
            opacity="0.5"
          ></path>{" "}
          <path
            id="Path_259"
            data-name="Path 259"
            d="M157.45,251.192c-.937.937-2.879.517-4.336-.94s-1.879-3.4-.942-4.335,2.879-.516,4.337.941S158.385,250.256,157.45,251.192Z"
            fill="#f3f3f3"
            opacity="0.5"
          ></path>{" "}
          <path
            id="Path_260"
            data-name="Path 260"
            d="M160.6,267.028l7.219,7.22a3.055,3.055,0,0,0,4.3-4.3l-7.219-7.219Z"
            fill="#5a6271"
          ></path>{" "}
        </g>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const CheckBoxSingle = ({
  width = "30",
  height = "30",
  fill,
}) => (
  <svg
    fill={fill}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        fillRule="evenodd"
        d="m15.12 2.23-9.79 9.78L.88 7.56 0 8.44l5.33 5.34L16 3.11l-.88-.88z"
      ></path>
    </g>
  </svg>
)

export const MacWindowControls = ({
  width = "30",
  height = "30",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 54 14"
    width={width}
    height={height}
  >
    <g fill="none" fillRule="evenodd" transform="translate(1 1)">
      <circle
        cx="6"
        cy="6"
        r="6"
        fill="#FF5F56"
        stroke="#E0443E"
        strokeWidth=".5"
      ></circle>
      <circle
        cx="26"
        cy="6"
        r="6"
        fill="#FFBD2E"
        stroke="#DEA123"
        strokeWidth=".5"
      ></circle>
      <circle
        cx="46"
        cy="6"
        r="6"
        fill="#27C93F"
        stroke="#1AAB29"
        strokeWidth=".5"
      ></circle>
    </g>
  </svg>
)

export const WindowsWindowControls = ({
  width = "30",
  height = "30",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 58 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 7H11"
      stroke="#878787"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M35 1H25C24.4477 1 24 1.44772 24 2V12C24 12.5523 24.4477 13 25 13H35C35.5523 13 36 12.5523 36 12V2C36 1.44772 35.5523 1 35 1Z"
      stroke="#878787"
    ></path>
    <path
      d="M47 2L57 12"
      stroke="#878787"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M47 12L57 2"
      stroke="#878787"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
)

export const FullscreenSolid = ({
  width = "30",
  height = "30",
  fill,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#212121"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M4 2C2.89543 2 2 2.89543 2 4V8C2 8.55228 2.44772 9 3 9C3.55228 9 4 8.55228 4 8V4H8C8.55228 4 9 3.55228 9 3C9 2.44772 8.55228 2 8 2H4Z"
        fill={fill}
      ></path>{" "}
      <path
        d="M20 2C21.1046 2 22 2.89543 22 4V8C22 8.55228 21.5523 9 21 9C20.4477 9 20 8.55228 20 8V4H16C15.4477 4 15 3.55228 15 3C15 2.44772 15.4477 2 16 2H20Z"
        fill={fill}
      ></path>{" "}
      <path
        d="M20 22C21.1046 22 22 21.1046 22 20V16C22 15.4477 21.5523 15 21 15C20.4477 15 20 15.4477 20 16V20H16C15.4477 20 15 20.4477 15 21C15 21.5523 15.4477 22 16 22H20Z"
        fill={fill}
      ></path>{" "}
      <path
        d="M2 20C2 21.1046 2.89543 22 4 22H8C8.55228 22 9 21.5523 9 21C9 20.4477 8.55228 20 8 20H4V16C4 15.4477 3.55228 15 3 15C2.44772 15 2 15.4477 2 16V20Z"
        fill={fill}
      ></path>{" "}
    </g>
  </svg>
)

export const FullscreenExitSolid = ({
  width = "30",
  height = "30",
  fill,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#212121"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M21.7071 3.70711L16.4142 9H20C20.5523 9 21 9.44772 21 10C21 10.5523 20.5523 11 20 11H14.0007L13.997 11C13.743 10.9992 13.4892 10.9023 13.295 10.7092L13.2908 10.705C13.196 10.6096 13.1243 10.4999 13.0759 10.3828C13.0273 10.2657 13.0004 10.1375 13 10.003L13 10V4C13 3.44772 13.4477 3 14 3C14.5523 3 15 3.44772 15 4V7.58579L20.2929 2.29289C20.6834 1.90237 21.3166 1.90237 21.7071 2.29289C22.0976 2.68342 22.0976 3.31658 21.7071 3.70711Z"
        fill={fill}
      ></path>{" "}
      <path
        d="M9 20C9 20.5523 9.44772 21 10 21C10.5523 21 11 20.5523 11 20V14.0007C11 13.9997 11 13.998 11 13.997C10.9992 13.7231 10.8883 13.4752 10.7092 13.295C10.7078 13.2936 10.7064 13.2922 10.705 13.2908C10.6096 13.196 10.4999 13.1243 10.3828 13.0759C10.2657 13.0273 10.1375 13.0004 10.003 13C10.002 13 10.001 13 10 13H4C3.44772 13 3 13.4477 3 14C3 14.5523 3.44772 15 4 15H7.58579L2.29289 20.2929C1.90237 20.6834 1.90237 21.3166 2.29289 21.7071C2.68342 22.0976 3.31658 22.0976 3.70711 21.7071L9 16.4142V20Z"
        fill={fill}
      ></path>{" "}
    </g>
  </svg>
)

export const LineWrappingSolid = ({
  width = "30",
  height = "30",
  fill,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <g id="Layer_2" data-name="Layer 2">
        {" "}
        <g id="invisible_box" data-name="invisible box">
          {" "}
          <rect width="48" height="48" fill="none"></rect>{" "}
        </g>{" "}
        <g id="Layer_7" data-name="Layer 7">
          {" "}
          <g>
            {" "}
            <path d="M4,13H44a2,2,0,0,0,0-4H4a2,2,0,0,0,0,4Z"></path>{" "}
            <path d="M18,33H4a2,2,0,0,0,0,4H18a2,2,0,0,0,0-4Z"></path>{" "}
            <path d="M38,21H4a2,2,0,0,0,0,4H38a4,4,0,0,1,0,8H30.8l2.6-2.6a2,2,0,0,0-2.8-2.8l-6,6a1.9,1.9,0,0,0,0,2.8l6,6a1.9,1.9,0,0,0,2.8,0,1.9,1.9,0,0,0,0-2.8L30.8,37H38a8,8,0,0,0,0-16Z"></path>{" "}
          </g>{" "}
        </g>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const NumberList = ({ width = "30", height = "30", fill }) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 36 36"
    version="1.1"
    preserveAspectRatio="xMidYMid meet"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <polygon
        points="5.46 7.41 5.46 11.56 6.65 11.56 6.65 6.05 5.7 6.05 4.05 7.16 4.52 8 5.46 7.41"
        className="clr-i-outline clr-i-outline-path-1"
      ></polygon>
      <path
        d="M5.57,14.82a.76.76,0,0,1,.83.73c0,.38-.21.74-.87,1.27l-2,1.57v1H7.67V18.28H5.33l1-.77c1-.7,1.28-1.27,1.28-2a1.83,1.83,0,0,0-2-1.76,2.63,2.63,0,0,0-2.14,1.08l.76.73A1.75,1.75,0,0,1,5.57,14.82Z"
        className="clr-i-outline clr-i-outline-path-2"
      ></path>
      <path
        d="M6.56,24.64a1.32,1.32,0,0,0,1-1.27c0-.87-.78-1.51-2-1.51a2.61,2.61,0,0,0-2.1,1l.69.72a1.78,1.78,0,0,1,1.3-.64c.54,0,.92.26.92.66s-.36.62-1,.62H4.79v1h.64c.74,0,1.07.21,1.07.63s-.35.68-1,.68a2,2,0,0,1-1.46-.65l-.7.78a2.85,2.85,0,0,0,2.21.93c1.29,0,2.13-.69,2.13-1.64A1.33,1.33,0,0,0,6.56,24.64Z"
        className="clr-i-outline clr-i-outline-path-3"
      ></path>
      <path
        d="M32.42,9a1,1,0,0,0-1-1H10v2H31.42A1,1,0,0,0,32.42,9Z"
        className="clr-i-outline clr-i-outline-path-4"
      ></path>
      <path
        d="M31.42,16H10v2H31.42a1,1,0,0,0,0-2Z"
        className="clr-i-outline clr-i-outline-path-5"
      ></path>
      <path
        d="M31.42,24H10v2H31.42a1,1,0,0,0,0-2Z"
        className="clr-i-outline clr-i-outline-path-6"
      ></path>{" "}
      <rect x="0" y="0" width="36" height="36" fillOpacity="0"></rect>{" "}
    </g>
  </svg>
)

export const FoldGutter = ({ width = "30", height = "30", fill }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <g fill={fill}>
        {" "}
        <path d="M8 6a.75.75 0 00.55-.24l3.25-3.5a.75.75 0 10-1.1-1.02L8 4.148 5.3 1.24a.75.75 0 00-1.1 1.02l3.25 3.5A.75.75 0 008 6zM8 10a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L8 11.852 5.3 14.76a.75.75 0 11-1.1-1.02l3.25-3.5A.75.75 0 018 10zM1.75 7.124a.626.626 0 100 1.253h.5a.627.627 0 000-1.253h-.5zM4.75 7.124a.626.626 0 100 1.253h.5a.627.627 0 000-1.253h-.5zM7.75 7.124a.626.626 0 100 1.253h.5a.627.627 0 000-1.253h-.5zM10.75 7.124a.627.627 0 000 1.253h.5a.627.627 0 000-1.253h-.5zM13.75 7.124a.627.627 0 000 1.253h.5a.627.627 0 000-1.253h-.5z"></path>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const CogSolid = ({ width = "30", height = "30", fill }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <g transform="translate(0 -1028.4)">
        {" "}
        <path
          d="m4.2218 1031.2 2.1213 0.7 0.1548 0.1c0.3432-0.2 0.6978-0.4 1.0606-0.6l-0.0663-0.2 0.4199-2.2 1.9445-0.5 1.4804 1.7 0.044 0.2c0.416-0.1 0.822-0.1 1.238 0l0.044-0.2 1.48-1.7 1.945 0.5 0.42 2.2-0.066 0.2c0.362 0.2 0.717 0.4 1.06 0.6l0.155-0.1 2.121-0.7 1.414 1.4-0.707 2.1-0.154 0.2c0.226 0.3 0.438 0.7 0.618 1h0.199l2.188 0.4 0.53 1.9-1.701 1.5h-0.177c0.026 0.5 0.026 0.9 0 1.3h0.177l1.701 1.5-0.53 2-2.188 0.4-0.199-0.1c-0.18 0.4-0.392 0.7-0.618 1.1l0.154 0.1 0.707 2.1-1.414 1.5-2.121-0.8-0.155-0.1c-0.343 0.2-0.698 0.4-1.06 0.6l0.066 0.2-0.42 2.2-1.945 0.5-1.48-1.7-0.044-0.1h-1.238l-0.044 0.1-1.4804 1.7-1.9446-0.5-0.4198-2.2 0.0663-0.2c-0.3628-0.2-0.7174-0.4-1.0607-0.6l-0.1547 0.1-2.1213 0.8-1.4142-1.5 0.7071-2.1 0.1547-0.1c-0.2267-0.4-0.4389-0.7-0.6187-1.1l-0.1989 0.1-2.1876-0.4-0.53034-2 1.7015-1.5h0.1767c-0.0258-0.4-0.0258-0.8 0-1.3h-0.1767l-1.7015-1.5 0.53033-1.9 2.1876-0.4h0.1989c0.1798-0.3 0.3921-0.7 0.6187-1l-0.1547-0.2-0.7071-2.1 1.4142-1.4zm2.8285 4.2c-2.7337 2.7-2.7337 7.2 0 9.9 2.7336 2.7 7.1657 2.7 9.8997 0 2.733-2.7 2.733-7.2 0-9.9-2.734-2.7-7.1661-2.7-9.8997 0z"
          fill={fill}
        ></path>{" "}
        <path
          d="m6.3431 1034.7c3.1242-3.1 8.1899-3.1 11.314 0 3.124 3.1 3.124 8.2 0 11.3s-8.1896 3.1-11.314 0c-3.1241-3.1-3.124-8.2 0.0001-11.3zm1.4806 0.1 2.1655 2.1c0.8848-0.5 1.8958-0.7 2.8728-0.4l1.392-2.8c-2.142-0.7-4.5518-0.3-6.4303 1.1zm-1.4142 1.4c-1.4064 1.9-1.766 4.3-1.0386 6.4l2.718-1.4c-0.2171-1-0.0357-2 0.4861-2.8l-2.1655-2.2zm4.1765 2.7c-0.7813 0.8-0.7813 2.1 0 2.9 0.781 0.8 2.047 0.8 2.828 0s0.781-2.1 0-2.9c-0.781-0.7-2.047-0.7-2.828 0zm5.436-4.2-1.392 2.7c0.062 0 0.138 0.1 0.198 0.1 0.69 0.7 1.068 1.6 1.149 2.5l3.006 0.5c0.022-1.9-0.644-3.7-2.033-5.1-0.288-0.3-0.607-0.5-0.928-0.7zm-9.723 9.7c0.2271 0.3 0.4635 0.6 0.7513 0.9 1.3888 1.4 3.2177 2.1 5.0377 2l-0.442-3c-0.9 0-1.7854-0.4-2.4744-1.1-0.0602-0.1-0.0992-0.1-0.1547-0.2l-2.7179 1.4zm9.369-2.4c-0.194 0.4-0.474 0.8-0.84 1.2-0.365 0.4-0.79 0.6-1.237 0.8l0.464 3.1c1.058-0.4 2.058-1 2.895-1.8s1.421-1.8 1.745-2.9l-3.027-0.4z"
          fill="#7f8c8d"
        ></path>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const BuildingShadow = ({
  width = "30",
  height = "30",
  fill,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M2 2h10v19h11v1H1v-1h1zm1 19h8V3H3zm17.864-.94l.606-2.96-1.13.476-4.706-12.434 1.14-.45L14.27 3l-.674 2.946 1.108-.437 4.715 12.455-1.098.463zM8 5h2v2H8zm-4 7h2v-2H4zm0-5h2V5H4zm0 10h2v-2H4zm4-5h2v-2H8zm0 5h2v-2H8z"></path>
      <path fill="none" d="M0 0h24v24H0z"></path>
    </g>
  </svg>
)

export const SaveFile = ({ width = "30", height = "30", fill }) => (
  <svg
    fill={fill}
    width={width}
    height={height}
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 302.089 302.089"
    xmlSpace="preserve"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <g>
        {" "}
        <g id="Layer_5_44_">
          {" "}
          <g>
            {" "}
            <g>
              {" "}
              <path d="M221.209,161.634c0,2.691-2.201,4.895-4.893,4.895H55.181c-2.693,0-4.893-2.203-4.893-4.895v-3.261 c0-2.691,2.2-4.894,4.893-4.894h161.135c2.691,0,4.893,2.202,4.893,4.894V161.634z"></path>{" "}
            </g>{" "}
            <g>
              {" "}
              <path d="M149.197,200.301c0,2.691-2.201,4.895-4.892,4.895H55.182c-2.693,0-4.893-2.203-4.893-4.895v-3.261 c0-2.691,2.2-4.893,4.893-4.893h89.123c2.691,0,4.892,2.202,4.892,4.893V200.301z"></path>{" "}
            </g>{" "}
            <path d="M270.764,0.001c0,0-18.179,0-24.238,0c-4.5,0-4.053,4.126-4.053,4.126v64.506c0,6.263-5.125,11.388-11.388,11.388H71.004 c-6.263,0-11.388-5.125-11.388-11.388c0,0,0-49.766,0-66.444c0-2.188-1.836-2.188-1.836-2.188H31.325c-11,0-20,9-20,20v262.088 c0,11,9,20,20,20h239.439c11,0,20-9,20-20V20C290.764,9.001,281.764,0.001,270.764,0.001z M265.043,247c0,4.95-4.05,9-9,9H46.047 c-4.95,0-9-4.05-9-9V137c0-4.95,4.05-9,9-9h209.996c4.95,0,9,4.05,9,9V247z"></path>{" "}
            <path d="M90.28,0.001c-1.958,0-1.714,1.899-1.714,1.899v59.339c0,2.75,2.25,5,5,5h17.82c2.75,0,5-2.25,5-5V1.807 c0,0,0-1.807-1.794-1.807C108.436,0.001,96.806,0.001,90.28,0.001z"></path>{" "}
          </g>{" "}
        </g>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const TypescriptIcon = ({ width = "30", height = "30" }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    aria-label="TypeScript"
    role="img"
    viewBox="0 0 512 512"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <rect width="512" height="512" rx="15%" fill="#3178c6"></rect>
      <path
        fill="#ffffff"
        d="m233 284h64v-41H118v41h64v183h51zm84 173c8.1 4.2 18 7.3 29 9.4s23 3.1 35 3.1c12 0 23-1.1 34-3.4c11-2.3 20-6.1 28-11c8.1-5.3 15-12 19-21s7.1-19 7.1-32c0-9.1-1.4-17-4.1-24s-6.6-13-12-18c-5.1-5.3-11-10-18-14s-15-8.2-24-12c-6.6-2.7-12-5.3-18-7.9c-5.2-2.6-9.7-5.2-13-7.8c-3.7-2.7-6.5-5.5-8.5-8.4c-2-3-3-6.3-3-10c0-3.4.89-6.5 2.7-9.3s4.3-5.1 7.5-7.1c3.2-2 7.2-3.5 12-4.6c4.7-1.1 9.9-1.6 16-1.6c4.2 0 8.6.31 13 .94c4.6.63 9.3 1.6 14 2.9c4.7 1.3 9.3 2.9 14 4.9c4.4 2 8.5 4.3 12 6.9v-47c-7.6-2.9-16-5.1-25-6.5s-19-2.1-31-2.1c-12 0-23 1.3-34 3.8s-20 6.5-28 12c-8.1 5.4-14 12-19 21c-4.7 8.4-7 18-7 30c0 15 4.3 28 13 38c8.6 11 22 19 39 27c6.9 2.8 13 5.6 19 8.3s11 5.5 15 8.4c4.3 2.9 7.7 6.1 10 9.5c2.5 3.4 3.8 7.4 3.8 12c0 3.2-.78 6.2-2.3 9s-3.9 5.2-7.1 7.2s-7.1 3.6-12 4.8c-4.7 1.1-10 1.7-17 1.7c-11 0-22-1.9-32-5.7c-11-3.8-21-9.5-28.1-15.44z"
      ></path>
    </g>
  </svg>
)

export const BookmarkShape = ({
  width = "30",
  height = "30",
  fill,
}) => (
  <svg
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="-51.2 -51.2 614.40 614.40"
    xmlSpace="preserve"
    fill={fill}
    stroke={fill}
    transform="rotate(0)"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <polygon
        style={{ fill }}
        points="66.783,0 66.783,512 256,322.783 289.391,161.391 256,0 "
      ></polygon>{" "}
      <polygon
        style={{ fill }}
        points="256,0 256,322.783 445.217,512 445.217,0 "
      ></polygon>{" "}
    </g>
  </svg>
)

export const ColorDrop = ({
  width = "30",
  height = "30",
  primary,
  secondary,
}) => (
  <svg
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 351.621 351.621"
    xmlSpace="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <g id="XMLID_1034_">
        {" "}
        <g id="XMLID_1035_">
          {" "}
          <path
            id="XMLID_1036_"
            style={{ fill: primary }}
            d="M296.141,204.391c-0.338-2.527-0.783-5.109-1.329-7.738 c-0.545-2.629-1.19-5.306-1.927-8.024c-0.737-2.719-1.567-5.478-2.482-8.273c-3.202-9.782-7.444-19.996-12.411-30.374 c-1.419-2.965-2.898-5.943-4.428-8.928c-0.765-1.493-1.543-2.987-2.333-4.482c-1.58-2.991-3.208-5.985-4.876-8.978 c-3.337-5.985-6.837-11.96-10.441-17.876c-6.306-10.353-12.929-20.524-19.552-30.245c-8.515-12.499-17.03-24.253-24.872-34.694 c-1.743-2.32-3.452-4.575-5.121-6.759c-2.503-3.276-4.914-6.392-7.209-9.327c-1.53-1.957-3.008-3.833-4.428-5.622 c-2.129-2.684-4.125-5.172-5.962-7.444c-1.225-1.515-2.38-2.933-3.457-4.25C179.387,4.14,175.811,0,175.811,0 S54.706,140.135,54.706,215.379s54.22,136.242,121.104,136.242c2.09,0,4.168-0.06,6.232-0.177 c53.667-3.061,98.117-45.424,111.059-102.016c0.249-1.088,0.486-2.182,0.712-3.281c0.451-2.197,0.854-4.415,1.209-6.651 c1.243-7.828,1.892-15.887,1.892-24.117C296.914,211.852,296.648,208.183,296.141,204.391z"
          ></path>{" "}
          <path
            id="XMLID_1037_"
            style={{ fill: primary }}
            d="M175.811,0v351.621c66.884,0,121.104-60.998,121.104-136.242S175.811,0,175.811,0 z"
          ></path>{" "}
        </g>{" "}
        <g id="XMLID_1038_">
          {" "}
          <polygon
            id="XMLID_1039_"
            style={{ fill: secondary }}
            points="227.869,177.777 190.008,177.777 190.008,139.915 161.613,139.915 161.613,177.777 123.75,177.777 123.75,206.173 161.613,206.173 161.613,244.035 190.008,244.035 190.008,206.173 227.869,206.173 "
          ></polygon>{" "}
          <polygon
            id="XMLID_1040_"
            style={{ fill: secondary }}
            points="190.008,177.777 190.008,139.915 175.811,139.915 175.811,244.035 190.008,244.035 190.008,206.173 227.869,206.173 227.869,177.777 "
          ></polygon>{" "}
        </g>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const ScreenshotSolid = ({
  width = "30",
  height = "30",
  fill,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="#ffffff"
    className="capture-btn"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <g
        id="screenshot-icon"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        {" "}
        <g
          id="ic_fluent_screenshot_24_filled"
          fill={fill}
          fillRule="nonzero"
        >
          {" "}
          <path
            d="M17.25,3 C19.3210678,3 21,4.67893219 21,6.75 L21,17.25 C21,19.3210678 19.3210678,21 17.25,21 L6.75,21 C4.67893219,21 3,19.3210678 3,17.25 L3,6.75 C3,4.67893219 4.67893219,3 6.75,3 L17.25,3 Z M17.25,13 C16.8703042,13 16.556509,13.2821539 16.5068466,13.6482294 L16.5,13.75 L16.5,16 C16.5,16.2454222 16.3230914,16.4496 16.0898645,16.4919429 L16,16.5 L13.75,16.5 C13.3357864,16.5 13,16.8357864 13,17.25 C13,17.6296958 13.2821539,17.943491 13.6482294,17.9931534 L13.75,18 L16,18 C17.0543909,18 17.9181678,17.18415 17.9945144,16.1492661 L18,16 L18,13.75 C18,13.3357864 17.6642136,13 17.25,13 Z M6.75,13 C6.37030423,13 6.05650904,13.2821539 6.00684662,13.6482294 L6,13.75 L6,16 C6,17.0543909 6.81587733,17.9181678 7.85073759,17.9945144 L8,18 L10.25,18 C10.6642136,18 11,17.6642136 11,17.25 C11,16.8703042 10.7178461,16.556509 10.3517706,16.5068466 L10.25,16.5 L8,16.5 C7.75454222,16.5 7.5503921,16.3230914 7.50805575,16.0898645 L7.5,16 L7.5,13.75 C7.5,13.3357864 7.16421356,13 6.75,13 Z M10.25,6 L8,6 L7.85073759,6.00548573 C6.86762035,6.07801738 6.08213519,6.86122607 6.00604447,7.84334947 L6,8 L6,10.25 L6.00684662,10.3517706 C6.05650904,10.7178461 6.37030423,11 6.75,11 C7.12969577,11 7.44349096,10.7178461 7.49315338,10.3517706 L7.5,10.25 L7.5,8 L7.50805575,7.91012499 C7.54510005,7.70603303 7.70603303,7.54510005 7.91012499,7.50805575 L8,7.5 L10.25,7.5 L10.3517706,7.49315338 C10.7178461,7.44349096 11,7.12969577 11,6.75 C11,6.37030423 10.7178461,6.05650904 10.3517706,6.00684662 L10.25,6 Z M16,6 L13.75,6 C13.3357864,6 13,6.33578644 13,6.75 C13,7.12969577 13.2821539,7.44349096 13.6482294,7.49315338 L13.75,7.5 L16,7.5 C16.2454222,7.5 16.4496,7.67687704 16.4919429,7.91012499 L16.5,8 L16.5,10.25 C16.5,10.6642136 16.8357864,11 17.25,11 C17.6296958,11 17.943491,10.7178461 17.9931534,10.3517706 L18,10.25 L18,8 C18,6.94563773 17.18415,6.08183483 16.1492661,6.00548573 L16,6 Z"
            id="color"
            className="capture-btn"
          >
            {" "}
          </path>{" "}
        </g>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const BoldThin = ({ width = "30", height = "30", fill }) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 256 256"
    id="Flat"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path d="M162.27246,117.21094A39.99047,39.99047,0,0,0,140.00049,44l-76.00586-.00488h-.00049a4.0002,4.0002,0,0,0-4,4v152a3.99989,3.99989,0,0,0,4,4L152,204a44.00279,44.00279,0,0,0,10.27246-86.78906ZM67.99414,51.99512,140,52a32,32,0,0,1,0,64H67.99414ZM152,196l-84.00586-.00488V124H152a36,36,0,0,1,0,72Z"></path>{" "}
    </g>
  </svg>
)

export const ItalicThin = ({ width = "30", height = "30", fill }) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 256 256"
    id="Flat"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path d="M195.99414,55.99512a4.0002,4.0002,0,0,1-4,4h-37.1167l-45.33349,136h34.45019a4,4,0,0,1,0,8H104.00708l-.01245.001-.01221-.001H63.99414a4,4,0,0,1,0-8h37.1167l45.3335-136h-34.4502a4,4,0,0,1,0-8h80A4.0002,4.0002,0,0,1,195.99414,55.99512Z"></path>{" "}
    </g>
  </svg>
)

export const UnderlineThin = ({
  width = "30",
  height = "30",
  fill,
}) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 256 256"
    id="Flat"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path d="M220,216a4.0002,4.0002,0,0,1-4,4H40a4,4,0,0,1,0-8H216A4.0002,4.0002,0,0,1,220,216Zm-92-28a68.07713,68.07713,0,0,0,68-68V56a4,4,0,0,0-8,0v64a60,60,0,0,1-120,0V56a4,4,0,0,0-8,0v64A68.07713,68.07713,0,0,0,128,188Z"></path>{" "}
    </g>
  </svg>
)

export const FontColor = ({ width = "30", height = "30", fill }) => (
  <svg
    width={width}
    height={height}
    fill={"#212121"}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <g>
        {" "}
        <path fill={fill} d="M0 0h24v24H0z"></path>{" "}
        <path d="M15.246 14H8.754l-1.6 4H5l6-15h2l6 15h-2.154l-1.6-4zm-.8-2L12 5.885 9.554 12h4.892zM3 20h18v2H3v-2z"></path>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const WarningColored = ({ width = "30", height = "30" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
    role="img"
    className="iconify iconify--emojione"
    preserveAspectRatio="xMidYMid meet"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M5.9 62c-3.3 0-4.8-2.4-3.3-5.3L29.3 4.2c1.5-2.9 3.9-2.9 5.4 0l26.7 52.5c1.5 2.9 0 5.3-3.3 5.3H5.9z"
        fill="#ffce31"
      >
        {" "}
      </path>{" "}
      <g fill="#231f20">
        {" "}
        <path d="M27.8 23.6l2.8 18.5c.3 1.8 2.6 1.8 2.9 0l2.7-18.5c.5-7.2-8.9-7.2-8.4 0">
          {" "}
        </path>{" "}
        <circle cx="32" cy="49.6" r="4.2">
          {" "}
        </circle>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const AlignTextLeft = ({
  width = "30",
  height = "30",
  fill,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path d="M0 3.5H15M0 11.5H9M0 7.5H6" stroke={fill}></path>{" "}
    </g>
  </svg>
)

export const AlignTextCenter = ({
  width = "30",
  height = "30",
  fill,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M15 3.5H0M10 7.5H5M12 11.5H3"
        stroke={fill}
      ></path>{" "}
    </g>
  </svg>
)

export const AlignTextRight = ({
  width = "30",
  height = "30",
  fill,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M15 3.5H0M15 11.5H6M15 7.5H9"
        stroke={fill}
      ></path>{" "}
    </g>
  </svg>
)

export const Details = ({ width = "33", height = "33", fill }) => (
  <svg
    width={width}
    height={height}
    fill="#000000"
    viewBox="0 0 24 24"
    id="clipboard-add-3"
    data-name="Flat Color"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        id="primary"
        d="M15,5H5A2,2,0,0,0,3,7V20a2,2,0,0,0,2,2h8a1,1,0,0,0,1-1V17a2,2,0,0,1,2-2h0a1,1,0,0,0,1-1V7A2,2,0,0,0,15,5Z"
        style={{ fill: "#575757" }}
      ></path>
      <path
        id="secondary"
        d="M11,18H7a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Zm3-5a1,1,0,0,0-1-1H7a1,1,0,0,0,0,2h6A1,1,0,0,0,14,13ZM12,4A2,2,0,0,0,8,4H7A1,1,0,0,0,6,5V7A1,1,0,0,0,7,8h6a1,1,0,0,0,1-1V5a1,1,0,0,0-1-1Zm8,14H19V17a1,1,0,0,0-2,0v1H16a1,1,0,0,0,0,2h1v1a1,1,0,0,0,2,0V20h1a1,1,0,0,0,0-2Z"
        style={{ fill: fill }}
      ></path>
    </g>
  </svg>
)

export const PlusIcon = ({ width = "30", height = "30", fill }) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        fill="#444"
        d="M12 7h-3v-3h-2v3h-3v2h3v3h2v-3h3z"
      ></path>{" "}
      <path
        fill="#444"
        d="M15 1h-14v14h14v-14zM14 14h-12v-12h12v12z"
      ></path>{" "}
    </g>
  </svg>
)

export const Widget = ({ width = "26", height = "26", fill }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M2.55078 4.5C2.61472 3.84994 2.75923 3.41238 3.08582 3.08579C3.67161 2.5 4.61442 2.5 6.50004 2.5C8.38565 2.5 9.32846 2.5 9.91425 3.08579C10.5 3.67157 10.5 4.61438 10.5 6.5C10.5 8.38562 10.5 9.32843 9.91425 9.91421C9.32846 10.5 8.38565 10.5 6.50004 10.5C4.61442 10.5 3.67161 10.5 3.08582 9.91421C2.77645 9.60484 2.63047 9.19589 2.56158 8.60106"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>{" "}
      <path
        d="M21.4493 15.5C21.3853 14.8499 21.2408 14.4124 20.9142 14.0858C20.3284 13.5 19.3856 13.5 17.5 13.5C15.6144 13.5 14.6716 13.5 14.0858 14.0858C13.5 14.6716 13.5 15.6144 13.5 17.5C13.5 19.3856 13.5 20.3284 14.0858 20.9142C14.6716 21.5 15.6144 21.5 17.5 21.5C19.3856 21.5 20.3284 21.5 20.9142 20.9142C21.2408 20.5876 21.3853 20.1501 21.4493 19.5"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>{" "}
      <path
        d="M2.5 17.5C2.5 15.6144 2.5 14.6716 3.08579 14.0858C3.67157 13.5 4.61438 13.5 6.5 13.5C8.38562 13.5 9.32843 13.5 9.91421 14.0858C10.5 14.6716 10.5 15.6144 10.5 17.5C10.5 19.3856 10.5 20.3284 9.91421 20.9142C9.32843 21.5 8.38562 21.5 6.5 21.5C4.61438 21.5 3.67157 21.5 3.08579 20.9142C2.5 20.3284 2.5 19.3856 2.5 17.5Z"
        stroke={fill}
        strokeWidth="1.5"
      ></path>{" "}
      <path
        d="M13.5 6.5C13.5 4.61438 13.5 3.67157 14.0858 3.08579C14.6716 2.5 15.6144 2.5 17.5 2.5C19.3856 2.5 20.3284 2.5 20.9142 3.08579C21.5 3.67157 21.5 4.61438 21.5 6.5C21.5 8.38562 21.5 9.32843 20.9142 9.91421C20.3284 10.5 19.3856 10.5 17.5 10.5C15.6144 10.5 14.6716 10.5 14.0858 9.91421C13.5 9.32843 13.5 8.38562 13.5 6.5Z"
        stroke={fill}
        strokeWidth="1.5"
      ></path>{" "}
    </g>
  </svg>
)

export const Templates = ({ width = "26", height = "26", fill }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M55.64 22.751H35.09C34.5596 22.751 34.0509 22.9617 33.6758 23.3368C33.3007 23.7118 33.09 24.2205 33.09 24.751V55.571C33.0916 56.1009 33.3028 56.6087 33.6775 56.9834C34.0523 57.3582 34.5601 57.5694 35.09 57.571H55.64C56.1699 57.5694 56.6777 57.3582 57.0525 56.9834C57.4272 56.6087 57.6384 56.1009 57.64 55.571V24.751C57.64 24.2205 57.4293 23.7118 57.0542 23.3368C56.6791 22.9617 56.1704 22.751 55.64 22.751Z"
        fill="#999999"
      ></path>{" "}
      <path
        d="M55.64 5.62695H35.09C34.5596 5.62695 34.0509 5.83767 33.6758 6.21274C33.3007 6.58781 33.09 7.09652 33.09 7.62695V17.8969C33.0916 18.4269 33.3028 18.9347 33.6775 19.3094C34.0523 19.6841 34.5601 19.8954 35.09 19.8969H55.64C56.1699 19.8954 56.6777 19.6841 57.0525 19.3094C57.4272 18.9347 57.6384 18.4269 57.64 17.8969V7.62695C57.64 7.09652 57.4293 6.58781 57.0542 6.21274C56.6791 5.83767 56.1704 5.62695 55.64 5.62695Z"
        fill={fill}
      ></path>{" "}
      <path
        d="M28.24 36.451H7.7C6.59543 36.451 5.7 37.3465 5.7 38.451V55.5711C5.7 56.6756 6.59543 57.5711 7.7 57.5711H28.24C29.3446 57.5711 30.24 56.6756 30.24 55.5711V38.451C30.24 37.3465 29.3446 36.451 28.24 36.451Z"
        fill={fill}
      ></path>{" "}
      <path
        d="M28.24 5.62697H7.70002C7.43712 5.62604 7.17661 5.67714 6.93355 5.77733C6.69048 5.87751 6.46964 6.02477 6.28373 6.21068C6.09783 6.39658 5.95054 6.61742 5.85035 6.86049C5.75017 7.10355 5.6991 7.36406 5.70002 7.62697V31.557C5.70002 32.0874 5.91074 32.5961 6.28581 32.9712C6.66088 33.3462 7.16959 33.557 7.70002 33.557H28.24C28.7704 33.557 29.2791 33.3462 29.6542 32.9712C30.0293 32.5961 30.24 32.0874 30.24 31.557V7.62697C30.2409 7.36406 30.1898 7.10355 30.0896 6.86049C29.9895 6.61742 29.8422 6.39658 29.6563 6.21068C29.4704 6.02477 29.2495 5.87751 29.0065 5.77733C28.7634 5.67714 28.5029 5.62604 28.24 5.62697Z"
        fill="#999999"
      ></path>{" "}
    </g>
  </svg>
)

export const DeleteAllDescriptions = ({
  width = "26",
  height = "26",
  fill,
}) => (
  <svg
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        style={{ fill: "#666666" }}
        d="M472.984,472.984H45.544V45.544h427.44V472.984z M53.544,464.984h411.44V53.544H53.544V464.984z"
      ></path>{" "}
      <g>
        {" "}
        <rect
          x="412.904"
          style={{ fill: "#999999" }}
          width="99.096"
          height="99.096"
        ></rect>{" "}
        <rect
          y="412.904"
          style={{ fill: "#999999" }}
          width="99.096"
          height="99.096"
        ></rect>{" "}
        <rect
          style={{ fill: "#999999" }}
          width="99.096"
          height="99.096"
        ></rect>{" "}
        <rect
          x="412.904"
          y="412.904"
          style={{ fill: "#999999" }}
          width="99.096"
          height="99.096"
        ></rect>{" "}
      </g>{" "}
      <polygon
        style={{ fill: fill }}
        points="328.68,130.44 256,203.12 183.32,130.44 130.44,183.32 203.12,256 130.44,328.68 183.32,381.56 256,308.88 328.68,381.56 381.56,328.68 308.88,256 381.56,183.32 "
      ></polygon>{" "}
    </g>
  </svg>
)

export const Preview = ({ width = "26", height = "26", fill }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 1024 1024"
    className="icon"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    stroke="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M511.9 924.8C91.8 924.8 2.6 524.1 1.7 520.1L0 512l1.7-8.1c0.8-4 90-404.7 510.2-404.7s509.4 400.7 510.2 404.7l1.9 9.1-2.4 9c-0.9 4-110.5 402.8-509.7 402.8zM80.6 511.9c13.7 52.8 102.2 334.2 431.4 334.2 310.8 0 413.7-279.5 431.1-335.1-14.6-55.5-104.2-333.2-431.1-333.2-330.4 0-417.8 281-431.4 334.1z"
        fill={fill}
      ></path>
      <path
        d="M511.9 708.6c-108.4 0-196.6-88.2-196.6-196.6s88.2-196.6 196.6-196.6c21.7 0 39.3 17.6 39.3 39.3 0 21.7-17.6 39.3-39.3 39.3-65 0-117.9 52.9-117.9 117.9s52.9 117.9 117.9 117.9 118-52.8 118-117.8c0-24.8-7.6-48.5-21.9-68.5-12.7-17.7-8.6-42.2 9.1-54.9 17.7-12.7 42.2-8.6 54.8 9.1 24 33.5 36.6 73 36.6 114.3 0 108.4-88.2 196.6-196.6 196.6z"
        fill="#5F6379"
      ></path>
    </g>
  </svg>
)

export const Lock = ({ width = "26", height = "26", fill }) => (
  <svg
    height={height}
    width={width}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        style={{ fill: fill }}
        d="M381.738,231.178h-48.004V112.929c-0.048-35.843-29.09-64.885-64.933-64.925h-25.602 c-35.843,0.048-64.877,29.082-64.925,64.925v118.249H130.27V112.929C130.334,50.588,180.858,0.072,243.199,0h25.602 c62.341,0.064,112.865,50.588,112.937,112.929V231.178z"
      ></path>{" "}
      <path
        style={{ fill: fill }}
        d="M57.024,219.649V512h397.951V219.649H57.024z M276.378,380.51v54.404h-40.755V380.51 c-24.45-11.257-35.155-40.203-23.898-64.653c11.257-24.45,40.203-35.155,64.653-23.898c24.45,11.257,35.155,40.203,23.898,64.653 C295.411,367.173,286.938,375.645,276.378,380.51z"
      ></path>{" "}
    </g>
  </svg>
)

export const Unlock = ({ width = "26", height = "26", fill }) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 60 60"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        style={{ fill: fill, fillRule: "evenodd" }}
        d="M794,356h32a4,4,0,0,1,4,4v26a4,4,0,0,1-4,4H794a4,4,0,0,1-4-4V360A4,4,0,0,1,794,356Zm18,17.445V378a2,2,0,0,1-4,0v-4.555A4,4,0,1,1,812,373.445ZM796,352v-6a10,10,0,0,0-20,0v6h-6v-6a16,16,0,0,1,32,0v6h-6Z"
        id="unlock"
        transform="translate(-770 -330)"
      ></path>
    </g>
  </svg>
)

export const Create = ({ width = "26", height = "26", fill }) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <rect x="0" fill="none" width="24" height="24"></rect>{" "}
      <g>
        {" "}
        <path d="M21 14v5c0 1.105-.895 2-2 2H5c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2h5v2H5v14h14v-5h2z"></path>{" "}
        <path d="M21 7h-4V3h-2v4h-4v2h4v4h2V9h4"></path>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const ScreenshotError = ({ width = "26", height = "26" }) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <g transform="translate(0 -1028.4)">
        {" "}
        <path
          d="m3 1031.4v10c0 4.2 3.6322 8 9 10 5.368-2 9-5.8 9-10v-10h-18z"
          fill="#95a5a6"
        ></path>{" "}
        <path
          d="m3 1030.4v10c0 4.2 3.6322 8 9 10 5.368-2 9-5.8 9-10v-10h-18z"
          fill="#ecf0f1"
        ></path>{" "}
        <path
          d="m3 1030.4v10c0 4.2 3.6322 8 9 10v-20h-9z"
          fill="#bdc3c7"
        ></path>{" "}
        <path
          d="m5 1032.4v8c0 3.4 2.8251 6.4 7 8 4.175-1.6 7-4.6 7-8v-8h-14z"
          fill="#c0392b"
        ></path>{" "}
        <path
          d="m12 1032.4v16c4.175-1.6 7-4.6 7-8v-8h-7z"
          fill="#e74c3c"
        ></path>{" "}
        <path
          d="m9.1562 1036.5-1.4062 1.4 2.844 2.9-2.844 2.8 1.4062 1.4 2.8438-2.8 2.844 2.8 1.406-1.4-2.844-2.8 2.844-2.8-1.438-1.5-2.812 2.9-2.8438-2.9z"
          fill="#c0392b"
        ></path>{" "}
        <path
          d="m9.1562 1035.5-1.4062 1.4 2.844 2.9-2.844 2.8 1.4062 1.4 2.8438-2.8 2.844 2.8 1.406-1.4-2.844-2.8 2.844-2.8-1.438-1.5-2.812 2.9-2.8438-2.9z"
          fill="#ecf0f1"
        ></path>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const Substract = ({ width = "26", height = "26", fill }) => (
  <svg
    height={height}
    width={width}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    fill={fill}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <ellipse
        style={{ fill: fill }}
        cx="256"
        cy="256"
        rx="256"
        ry="255.832"
      ></ellipse>{" "}
      <rect
        x="113.2"
        y="228"
        style={{ fill: "#E21B1B" }}
        width="285.672"
        height="56"
      ></rect>{" "}
    </g>
  </svg>
)
export const AddPlus = ({
  width = "26",
  height = "26",
  fill,
  stroke,
}) => (
  <svg
    height={height}
    width={width}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <ellipse
        style={{ fill: fill }}
        cx="256"
        cy="256"
        rx="256"
        ry="255.832"
      ></ellipse>{" "}
      <g>
        {" "}
        <rect
          x="113.2"
          y="228"
          style={{ fill: stroke }}
          width="285.672"
          height="56"
        ></rect>{" "}
        <rect
          x="228"
          y="113.2"
          style={{ fill: stroke }}
          width="56"
          height="285.672"
        ></rect>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const XIcon = ({
  width = "26",
  height = "26",
  fill,
  title,
}) => (
  <svg
    height={height}
    width={width}
    version="1.1"
    id="svg5"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="320 50 1000 1221.19"
    style={{ enableBackground: "new 0 0 1668.56 1221.19" }}
    xmlSpace="preserve"
    fill={fill}
  >
    <title>{title}</title>
    <g id="layer1" transform="translate(52.390088,-25.058597)">
      <path
        id="path1009"
        d="M283.94,167.31l386.39,516.64L281.5,1104h87.51l340.42-367.76L984.48,1104h297.8L874.15,558.3l361.92-390.99
		h-87.51l-313.51,338.7l-253.31-338.7H283.94z M412.63,231.77h136.81l604.13,807.76h-136.81L412.63,231.77z"
      />
    </g>
  </svg>
)

export const Reload = ({ width = "26", height = "26", fill }) => (
  <svg
    height={height}
    width={width}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 473.677 473.677"
    xmlSpace="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        style={{ fill: fill }}
        d="M0,236.84C0,106.026,106.036,0.002,236.835,0.002c130.807,0,236.842,106.028,236.842,236.838 c0,130.795-106.036,236.835-236.842,236.835C106.039,473.671,0,367.636,0,236.84z"
      ></path>{" "}
      <g>
        {" "}
        <path
          style={{ fill: "#323232" }}
          d="M408.84,164.345c-9.88,0.022-19.756,0.049-29.636,0.075 c-22.217-49.815-65.828-85.797-120.912-94.428c-61.374-9.614-120.115,18.889-155.14,69.036 c-15.557,22.269,21.005,43.121,36.431,21.035c48.039-68.774,150.608-62.559,192.76,4.473c-9.125,0.022-18.253,0.045-27.377,0.067 c-2.554,0.004-4.368,1.144-5.49,2.745c-1.832,1.967-2.532,4.839-0.61,7.816c17.378,26.966,34.759,53.936,52.141,80.902 c2.921,4.532,9.226,4.495,12.12-0.045c17.243-27.052,34.49-54.104,51.733-81.16C417.714,170.388,413.956,164.334,408.84,164.345z"
        ></path>{" "}
        <path
          style={{ fill: "#323232" }}
          d="M334.479,312.395c-48.039,68.786-150.6,62.548-192.76-4.476c9.125-0.022,18.253-0.045,27.377-0.067 c2.554-0.007,4.368-1.144,5.49-2.745c1.832-1.963,2.528-4.839,0.61-7.816c-17.374-26.97-34.756-53.936-52.133-80.902 c-2.917-4.532-9.226-4.495-12.12,0.045c-17.243,27.052-34.494,54.104-51.741,81.16c-2.853,4.476,0.905,10.531,6.021,10.519 c9.88-0.026,19.756-0.049,29.64-0.075c22.221,49.815,65.828,85.797,120.915,94.432c61.374,9.614,120.115-18.889,155.132-69.036 C386.466,311.157,349.901,290.309,334.479,312.395z"
        ></path>{" "}
      </g>{" "}
      <path
        style={{ fill: "#575758" }}
        d="M214.865,238.089c0-12.146,9.839-21.985,21.977-21.985c12.139,0,21.977,9.839,21.977,21.985 c0,12.131-9.839,21.97-21.977,21.97C224.704,260.059,214.865,250.217,214.865,238.089z"
      ></path>{" "}
    </g>
  </svg>
)

export const NAIcon = ({ width = "26", height = "26", color }) => (
  <svg
    viewBox="0 0 500 500"
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="100%"
      height="100%"
      style={{
        fill: "rgba(216, 216, 216, 0)",
        strokeWidth: "10",
        stroke: color,
      }}
    />
    <path
      d="M 177.27 210 L 173.534 210 L 166.263 198.072 L 166.263 210 L 162.528 210 L 162.528 191.871 L 166.263 191.871 L 173.547 203.824 L 173.547 191.871 L 177.27 191.871 Z"
      transform="matrix(8.646578, 0, 0, 12.734641, 71.474426, 38.977829)"
      style={{
        fill: color,
        paintOrder: "fill",
        strokeLinecap: "round",
        strokeWidth: "1.22405px",
        transformOrigin: "182.132px 200.452px",
      }}
    />
    <path
      d="M 183.245 213.362 L 181.066 213.362 L 181.066 191.871 L 183.245 191.871 Z"
      transform="matrix(8.646578, 0, 0, 12.734641, 71.474426, 38.977829)"
      style={{
        fill: color,
        paintOrder: "fill",
        strokeLinecap: "round",
        strokeWidth: "1.22405px",
        transformOrigin: "182.132px 200.452px",
      }}
    />
    <path
      d="M 197.216 206.265 L 190.666 206.265 L 189.421 210 L 185.449 210 L 192.198 191.871 L 195.659 191.871 L 202.445 210 L 198.473 210 Z M 191.675 203.239 L 196.207 203.239 L 193.929 196.453 Z"
      transform="matrix(8.646578, 0, 0, 12.734641, 71.474426, 38.977829)"
      style={{
        fill: color,
        paintOrder: "fill",
        strokeLinecap: "round",
        strokeWidth: "1.22405px",
        transformOrigin: "182.132px 200.452px",
      }}
    />
  </svg>
)

export const FormatCode = ({ width = "26", height = "26", fill }) => (
  <svg
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <circle
        style={{ fill: fill }}
        cx="256"
        cy="256"
        r="256"
      ></circle>{" "}
      <g>
        {" "}
        <rect
          x="125.12"
          y="117.12"
          style={{ fill: "#333333" }}
          width="194.8"
          height="16"
        ></rect>{" "}
        <rect
          x="192.16"
          y="174.96"
          style={{ fill: "#333333" }}
          width="194.8"
          height="16"
        ></rect>{" "}
        <rect
          x="125.12"
          y="248"
          style={{ fill: "#333333" }}
          width="194.8"
          height="16"
        ></rect>{" "}
        <rect
          x="192.16"
          y="305.76"
          style={{ fill: "#333333" }}
          width="194.8"
          height="16"
        ></rect>{" "}
        <rect
          x="125.12"
          y="378.88"
          style={{ fill: "#333333" }}
          width="194.8"
          height="16"
        ></rect>{" "}
      </g>{" "}
    </g>
  </svg>
)

export const SnippifyLogo = ({
  width = "26",
  height = "26",
  fill,
}) => (
  <svg
    viewBox="648.747 28.182 479.091 421.999"
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M 392.136 308.182 Q 371.736 308.182 362.585 306.382 Q 353.434 304.582 354.032 302.182 L 381.681 263.482 Q 388.282 264.682 409.62 265.732 Q 430.958 266.782 465.458 266.782 L 489.158 266.782 Q 499.658 266.782 504.006 263.782 Q 508.354 260.782 509.775 255.082 L 510.523 252.082 Q 512.319 244.882 509.392 242.182 Q 506.465 239.482 495.965 239.482 L 427.265 239.482 Q 396.965 239.482 385.97 228.232 Q 374.975 216.982 381.333 191.482 L 384.025 180.682 Q 387.317 167.482 395.034 156.382 Q 402.752 145.282 416.435 138.532 Q 430.118 131.782 451.118 131.782 L 550.718 131.782 Q 569.018 131.782 580.644 133.882 Q 592.27 135.982 591.672 138.382 L 573.397 175.582 Q 565.221 174.682 542.233 173.632 Q 519.245 172.582 483.545 172.582 L 462.02 172.282 Q 452.72 172.282 448.184 174.832 Q 443.648 177.382 441.628 184.282 L 441.104 186.382 Q 439.384 193.282 442.911 195.982 Q 446.438 198.682 455.738 198.682 L 521.738 198.682 Q 540.938 198.682 553.465 202.582 Q 565.993 206.482 570.612 216.832 Q 575.232 227.182 570.22 247.282 L 567.528 258.082 Q 561.918 280.582 546.927 294.382 Q 531.936 308.182 503.436 308.182 Z"
      transform="matrix(1.081077, -0.577682, 0.559188, 1.089325, 416.572662, 19.938)"
      style={{
        fill: fill,
        stroke: fill,
        strokeWidth: "69.0801px",
        transformOrigin: "465.487px 218.345px",
      }}
    />
    <path
      d="M 392.137 308.182 Q 371.737 308.182 362.586 306.382 Q 353.435 304.582 354.033 302.182 L 381.682 263.482 Q 388.283 264.682 409.621 265.732 Q 430.959 266.782 465.459 266.782 L 489.159 266.782 Q 499.659 266.782 504.007 263.782 Q 508.355 260.782 509.777 255.082 L 510.525 252.082 Q 512.32 244.882 509.393 242.182 Q 506.466 239.482 495.966 239.482 L 427.266 239.482 Q 396.966 239.482 385.971 228.232 Q 374.976 216.982 381.334 191.482 L 384.027 180.682 Q 387.318 167.482 395.035 156.382 Q 402.753 145.282 416.436 138.532 Q 430.119 131.782 451.119 131.782 L 550.719 131.782 Q 569.019 131.782 580.645 133.882 Q 592.272 135.982 591.673 138.382 L 573.398 175.582 Q 565.223 174.682 542.234 173.632 Q 519.246 172.582 483.546 172.582 L 462.021 172.282 Q 452.721 172.282 448.185 174.832 Q 443.649 177.382 441.629 184.282 L 441.105 186.382 Q 439.385 193.282 442.912 195.982 Q 446.439 198.682 455.739 198.682 L 521.739 198.682 Q 540.939 198.682 553.466 202.582 Q 565.994 206.482 570.613 216.832 Q 575.233 227.182 570.221 247.282 L 567.529 258.082 Q 561.919 280.582 546.928 294.382 Q 531.937 308.182 503.437 308.182 Z"
      transform="matrix(1.010192, 0, -0.016459, 0.997664, 424.864166, 14.54019)"
      style={{
        fill: "#454545",
        stroke: "#454545",
        strokeWidth: "0px",
        transformOrigin: "465.481px 218.13px",
      }}
    />
  </svg>
)

export const InfoTip = ({ width = "26", height = "26", fill }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.877075 7.49972C0.877075 3.84204 3.84222 0.876892 7.49991 0.876892C11.1576 0.876892 14.1227 3.84204 14.1227 7.49972C14.1227 11.1574 11.1576 14.1226 7.49991 14.1226C3.84222 14.1226 0.877075 11.1574 0.877075 7.49972ZM7.49991 1.82689C4.36689 1.82689 1.82708 4.36671 1.82708 7.49972C1.82708 10.6327 4.36689 13.1726 7.49991 13.1726C10.6329 13.1726 13.1727 10.6327 13.1727 7.49972C13.1727 4.36671 10.6329 1.82689 7.49991 1.82689ZM8.24993 10.5C8.24993 10.9142 7.91414 11.25 7.49993 11.25C7.08571 11.25 6.74993 10.9142 6.74993 10.5C6.74993 10.0858 7.08571 9.75 7.49993 9.75C7.91414 9.75 8.24993 10.0858 8.24993 10.5ZM6.05003 6.25C6.05003 5.57211 6.63511 4.925 7.50003 4.925C8.36496 4.925 8.95003 5.57211 8.95003 6.25C8.95003 6.74118 8.68002 6.99212 8.21447 7.27494C8.16251 7.30651 8.10258 7.34131 8.03847 7.37854L8.03841 7.37858C7.85521 7.48497 7.63788 7.61119 7.47449 7.73849C7.23214 7.92732 6.95003 8.23198 6.95003 8.7C6.95004 9.00376 7.19628 9.25 7.50004 9.25C7.8024 9.25 8.04778 9.00601 8.05002 8.70417L8.05056 8.7033C8.05924 8.6896 8.08493 8.65735 8.15058 8.6062C8.25207 8.52712 8.36508 8.46163 8.51567 8.37436L8.51571 8.37433C8.59422 8.32883 8.68296 8.27741 8.78559 8.21506C9.32004 7.89038 10.05 7.35382 10.05 6.25C10.05 4.92789 8.93511 3.825 7.50003 3.825C6.06496 3.825 4.95003 4.92789 4.95003 6.25C4.95003 6.55376 5.19628 6.8 5.50003 6.8C5.80379 6.8 6.05003 6.55376 6.05003 6.25Z"
        fill={fill}
      ></path>{" "}
    </g>
  </svg>
)

export const ShieldCheck = ({ width = "26", height = "26" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.37752 5.08241C3 5.62028 3 7.21907 3 10.4167V11.9914C3 17.6294 7.23896 20.3655 9.89856 21.5273C10.62 21.8424 10.9807 22 12 22C13.0193 22 13.38 21.8424 14.1014 21.5273C16.761 20.3655 21 17.6294 21 11.9914V10.4167C21 7.21907 21 5.62028 20.6225 5.08241C20.245 4.54454 18.7417 4.02996 15.7351 3.00079L15.1623 2.80472C13.595 2.26824 12.8114 2 12 2C11.1886 2 10.405 2.26824 8.83772 2.80472L8.26491 3.00079C5.25832 4.02996 3.75503 4.54454 3.37752 5.08241ZM15.0595 10.4995C15.3353 10.1905 15.3085 9.71642 14.9995 9.44055C14.6905 9.16467 14.2164 9.19151 13.9405 9.50049L10.9286 12.8739L10.0595 11.9005C9.78358 11.5915 9.30947 11.5647 9.00049 11.8405C8.69151 12.1164 8.66467 12.5905 8.94055 12.8995L10.3691 14.4995C10.5114 14.6589 10.7149 14.75 10.9286 14.75C11.1422 14.75 11.3457 14.6589 11.488 14.4995L15.0595 10.4995Z"
        fill="#237e01"
      ></path>{" "}
    </g>
  </svg>
)
